// // BusRouteScheduleManage.jsx
// import React, { useState, useEffect } from 'react';
// import { useSelector } from 'react-redux';
// import { toast } from 'react-toastify';
// import {
//     getAllBusRouteSchedules,
//     getBusRouteSchedule,
//     updateBusRouteSchedule,
//     getPointDisabledDates
// } from '../../Services/Operations/ProductAPI';
// import '../../Styles/BusRouteSchedule.css';

// // Helper Components
// const TimeDisplay = ({ time }) => {
//     if (!time) return '--:--';
//     if (time.includes(':')) {
//         const [hours, minutes] = time.split(':');
//         const hour = parseInt(hours);
//         const ampm = hour >= 12 ? 'PM' : 'AM';
//         const displayHour = hour % 12 || 12;
//         return `${displayHour}:${minutes} ${ampm}`;
//     }
//     return time;
// };

// const StatusBadge = ({ isActive }) => (
//     <span className={`status-badge ${isActive ? 'active' : 'inactive'}`}>
//         {isActive ? 'Active' : 'Inactive'}
//     </span>
// );

// const StopTypeBadge = ({ type }) => {
//     const types = {
//         boarding: { label: 'Boarding', className: 'boarding' },
//         dropping: { label: 'Dropping', className: 'dropping' },
//         both: { label: 'Both', className: 'both' },
//         none: { label: 'Pass-through', className: 'none' }
//     };
//     const info = types[type] || types.none;
//     return <span className={`stop-type-badge ${info.className}`}>{info.label}</span>;
// };

// const SkeletonRow = () => (
//     <tr className="skeleton-row">
//         <td><div className="skeleton-cell"></div></td>
//         <td><div className="skeleton-cell"></div></td>
//         <td><div className="skeleton-cell"></div></td>
//         <td><div className="skeleton-cell"></div></td>
//         <td><div className="skeleton-cell"></div></td>
//         <td><div className="skeleton-cell"></div></td>
//         <td><div className="skeleton-cell"></div></td>
//         <td><div className="skeleton-badge"></div></td>
//         <td><div className="skeleton-badge"></div></td>
//         <td><div className="skeleton-actions"></div></td>
//     </tr>
// );

// const SkeletonLoader = () => (
//     <div className="brs-container">
//         <div className="brs-header">
//             <div className="skeleton-title"></div>
//             <div className="skeleton-search"></div>
//         </div>
//         <div className="stats-cards">
//             {[1, 2, 3, 4].map(i => <div key={i} className="stat-card skeleton"><div className="skeleton-stat"></div></div>)}
//         </div>
//         <div className="table-container">
//             <table className="data-table">
//                 <thead>
//                     <tr>
//                         <th>No.</th>
//                         <th>Bus Name</th>
//                         <th>Bus Number</th>
//                         <th>Route</th>
//                         <th>Origin</th>
//                         <th>Destination</th>
//                         <th>Distance</th>
//                         <th>Stops</th>
//                         <th>Type</th>
//                         <th>Status</th>
//                         <th>Actions</th>
//                     </tr>
//                 </thead>
//                 <tbody>
//                     {[1, 2, 3, 4, 5].map(i => <SkeletonRow key={i} />)}
//                 </tbody>
//             </table>
//         </div>
//     </div>
// );

// const BusRouteScheduleManage = () => {
//     const { token } = useSelector(state => state.user);

//     const [loading, setLoading] = useState(true);
//     const [schedules, setSchedules] = useState([]);
//     const [searchTerm, setSearchTerm] = useState('');
//     const [currentPage, setCurrentPage] = useState(1);
//     const [totalPages, setTotalPages] = useState(1);
//     const [totalItems, setTotalItems] = useState(0);
//     const [stats, setStats] = useState({
//         total: 0,
//         active: 0,
//         inactive: 0,
//         withSchedules: 0,
//         withoutSchedules: 0
//     });
//     const pageSize = 10;

//     // Filters
//     const [filters, setFilters] = useState({
//         status: '',
//         busType: '',
//         routeType: ''
//     });

//     // Edit Modal States
//     const [showEditModal, setShowEditModal] = useState(false);
//     const [editingSchedule, setEditingSchedule] = useState(null);
//     const [scheduleData, setScheduleData] = useState(null);
//     const [editData, setEditData] = useState({});
//     const [isUpdating, setIsUpdating] = useState(false);
//     const [activeTab, setActiveTab] = useState('UP');
//     const [showDisabledDatesModal, setShowDisabledDatesModal] = useState(false);
//     const [disabledDates, setDisabledDates] = useState([]);
//     const [loadingSchedule, setLoadingSchedule] = useState(false);

//     // Fetch bus route schedules using the new API
//     useEffect(() => {
//         fetchSchedules();
//     }, [currentPage, filters]);

//     const fetchSchedules = async () => {
//         try {
//             setLoading(true);
//             const response = await getAllBusRouteSchedules(
//                 token,
//                 currentPage,
//                 pageSize,
//                 searchTerm,
//                 filters
//             );
//             console.log('Schedules response:', response);

//             if (response && response.success) {
//                 setSchedules(response.data.schedules || []);
//                 setTotalPages(response.data.pagination?.totalPages || 1);
//                 setTotalItems(response.data.pagination?.totalItems || 0);
//                 setStats(response.data.stats || {
//                     total: 0,
//                     active: 0,
//                     inactive: 0,
//                     withSchedules: 0,
//                     withoutSchedules: 0
//                 });
//             } else {
//                 toast.error(response.message || 'Failed to fetch bus schedules');
//             }
//         } catch (error) {
//             console.error('Error fetching schedules:', error);
//             toast.error(error.message || 'Failed to fetch bus schedules');
//         } finally {
//             setLoading(false);
//         }
//     };

//     const handleSearch = (e) => {
//         setSearchTerm(e.target.value);
//         setCurrentPage(1);
//         const timer = setTimeout(() => fetchSchedules(), 500);
//         return () => clearTimeout(timer);
//     };

//     const handleFilterChange = (key, value) => {
//         setFilters(prev => ({ ...prev, [key]: value }));
//         setCurrentPage(1);
//     };

//     // Open Edit Modal - Fetch full schedule data using the single bus API
//     const handleEditSchedule = async (schedule) => {
//         try {
//             setLoadingSchedule(true);
//             setEditingSchedule(schedule);

//             // Get the bus ID from the schedule
//             const busId = schedule.busId?._id || schedule.busId;

//             // Fetch full schedule data for this bus
//             const response = await getBusRouteSchedule(busId, token);
//             console.log('Full schedule data:', response);

//             if (response.success) {
//                 setScheduleData(response.data);
//                 setEditData(response.data);
//                 setShowEditModal(true);
//                 setActiveTab('UP');
//             } else {
//                 toast.error('Failed to fetch schedule details');
//             }
//         } catch (error) {
//             console.error('Error fetching schedule:', error);
//             toast.error(error.message || 'Failed to fetch schedule details');
//         } finally {
//             setLoadingSchedule(false);
//         }
//     };

//     // Save changes from edit modal
//     const handleSaveChanges = async () => {
//         try {
//             setIsUpdating(true);

//             const busId = editingSchedule.busId?._id || editingSchedule.busId;
//             const updatePayload = {};

//             if (editData.busInfo) {
//                 updatePayload.busInfo = editData.busInfo;
//             }

//             if (editData.isActive !== undefined) {
//                 updatePayload.isActive = editData.isActive;
//             }

//             if (editData.routeSchedules) {
//                 updatePayload.routeSchedules = editData.routeSchedules;
//             }

//             const response = await updateBusRouteSchedule(busId, updatePayload, token);

//             if (response.success) {
//                 toast.success('Schedule updated successfully!');
//                 setShowEditModal(false);
//                 fetchSchedules(); // Refresh the table
//             } else {
//                 toast.error(response.message || 'Failed to update schedule');
//             }
//         } catch (error) {
//             console.error('Error updating schedule:', error);
//             toast.error(error.message || 'Failed to update schedule');
//         } finally {
//             setIsUpdating(false);
//         }
//     };

//     // Toggle functions for edit modal
//     const handleToggleStop = async (routeId, stopId, enabled) => {
//         try {
//             const busId = editingSchedule.busId?._id || editingSchedule.busId;
//             const response = await updateBusRouteSchedule(busId, {
//                 toggleStop: { routeId, stopId, enabled }
//             }, token);

//             if (response.success) {
//                 toast.success(`Stop ${enabled ? 'enabled' : 'disabled'} successfully`);
//                 // Refresh schedule data
//                 const refreshResponse = await getBusRouteSchedule(busId, token);
//                 if (refreshResponse.success) {
//                     setScheduleData(refreshResponse.data);
//                     setEditData(refreshResponse.data);
//                 }
//             }
//         } catch (error) {
//             console.error('Error toggling stop:', error);
//             toast.error('Failed to update stop');
//         }
//     };

//     const handleToggleBoardingPoint = async (routeId, pointId, enabled) => {
//         try {
//             const busId = editingSchedule.busId?._id || editingSchedule.busId;
//             const response = await updateBusRouteSchedule(busId, {
//                 toggleBoardingPoint: { routeId, pointId, enabled }
//             }, token);

//             if (response.success) {
//                 toast.success(`Boarding point ${enabled ? 'enabled' : 'disabled'} successfully`);
//                 const refreshResponse = await getBusRouteSchedule(busId, token);
//                 if (refreshResponse.success) {
//                     setScheduleData(refreshResponse.data);
//                     setEditData(refreshResponse.data);
//                 }
//             }
//         } catch (error) {
//             console.error('Error toggling boarding point:', error);
//             toast.error('Failed to update boarding point');
//         }
//     };

//     const handleToggleDroppingPoint = async (routeId, pointId, enabled) => {
//         try {
//             const busId = editingSchedule.busId?._id || editingSchedule.busId;
//             const response = await updateBusRouteSchedule(busId, {
//                 toggleDroppingPoint: { routeId, pointId, enabled }
//             }, token);

//             if (response.success) {
//                 toast.success(`Dropping point ${enabled ? 'enabled' : 'disabled'} successfully`);
//                 const refreshResponse = await getBusRouteSchedule(busId, token);
//                 if (refreshResponse.success) {
//                     setScheduleData(refreshResponse.data);
//                     setEditData(refreshResponse.data);
//                 }
//             }
//         } catch (error) {
//             console.error('Error toggling dropping point:', error);
//             toast.error('Failed to update dropping point');
//         }
//     };

//     const handleViewDisabledDates = async (pointId) => {
//         try {
//             const busId = editingSchedule.busId?._id || editingSchedule.busId;
//             const response = await getPointDisabledDates(busId, pointId, token);
//             if (response.success) {
//                 setDisabledDates(response.data);
//                 setShowDisabledDatesModal(true);
//             }
//         } catch (error) {
//             console.error('Error fetching disabled dates:', error);
//             toast.error('Failed to fetch disabled dates');
//         }
//     };

//     const getRouteSchedule = (direction) => {
//         if (!scheduleData?.routeSchedules) return null;
//         return scheduleData.routeSchedules.find(r => r.direction === direction);
//     };

//     const upRoute = getRouteSchedule('UP');
//     const downRoute = getRouteSchedule('DOWN');

//     // Render functions for edit modal
//     const renderTimings = (timings) => {
//         if (!timings || timings.length === 0) return 'N/A';
//         return timings.map(t => (
//             <div key={t.timeSlotSequence} className="timing-item">
//                 Trip {t.timeSlotSequence}: {t.departureTime ? `Dep ${TimeDisplay({ time: t.departureTime })}` : ''}
//                 {t.arrivalTime ? ` → Arr ${TimeDisplay({ time: t.arrivalTime })}` : ''}
//             </div>
//         ));
//     };

//     const renderStopTimings = (stop) => {
//         if (stop.timings && stop.timings.length > 0) {
//             return stop.timings.map(t => (
//                 <div key={t.timeSlotSequence} className="stop-timing">
//                     <span className="trip-label">Trip {t.timeSlotSequence}:</span>
//                     <span className="time-arr">Arr {TimeDisplay({ time: t.arrivalTime })}</span>
//                     <span className="time-dep">Dep {TimeDisplay({ time: t.departureTime })}</span>
//                 </div>
//             ));
//         }
//         return (
//             <div className="stop-timing">
//                 <span className="time-arr">Arr {TimeDisplay({ time: stop.arrivalTime })}</span>
//                 <span className="time-dep">Dep {TimeDisplay({ time: stop.departureTime })}</span>
//             </div>
//         );
//     };

//     const renderEditBusInfo = () => {
//         const info = scheduleData?.busInfo;
//         if (!info) return null;

//         return (
//             <div className="bus-info-section">
//                 <div className="bus-info-header">
//                     <h2>{info.busName || 'Bus'}</h2>
//                     <StatusBadge isActive={scheduleData?.isActive !== false} />
//                 </div>
//                 <div className="bus-info-grid">
//                     <div className="info-item">
//                         <label>Bus Number</label>
//                         <span>{info.busNumber || 'N/A'}</span>
//                     </div>
//                     <div className="info-item">
//                         <label>Type</label>
//                         <span>{info.busType || 'N/A'}</span>
//                     </div>
//                     <div className="info-item">
//                         <label>Category</label>
//                         <span>{info.busCategory || 'N/A'}</span>
//                     </div>
//                     <div className="info-item">
//                         <label>Class</label>
//                         <span>{info.busClass || 'Standard'}</span>
//                     </div>
//                     <div className="info-item">
//                         <label>Total Seats</label>
//                         <span>{info.totalSeats || 0}</span>
//                     </div>
//                     <div className="info-item">
//                         <label>Available Seats</label>
//                         <span>{info.availableSeats || 0}</span>
//                     </div>
//                 </div>
//                 {info.amenities && info.amenities.length > 0 && (
//                     <div className="amenities-section">
//                         <label>Amenities</label>
//                         <div className="amenities-list">
//                             {info.amenities.map((amenity, idx) => (
//                                 <span key={idx} className="amenity-tag">{amenity}</span>
//                             ))}
//                         </div>
//                     </div>
//                 )}
//                 {info.images && info.images.length > 0 && (
//                     <div className="images-section">
//                         <label>Images</label>
//                         <div className="images-list">
//                             {info.images.map((img, idx) => (
//                                 <img key={idx} src={`/uploads/${img}`} alt={`Bus ${idx + 1}`} />
//                             ))}
//                         </div>
//                     </div>
//                 )}
//             </div>
//         );
//     };

//     const renderRouteDetails = (route, direction) => {
//         if (!route) return null;

//         const isMultiTrip = route.origin?.timings && route.origin.timings.length > 0;

//         return (
//             <div className="route-details-section">
//                 <div className="route-header">
//                     <h3>{direction} Route</h3>
//                 </div>

//                 <div className="route-info">
//                     <div className="info-item">
//                         <label>Route Name</label>
//                         <span>{route.routeName}</span>
//                     </div>
//                     <div className="info-item">
//                         <label>Route Number</label>
//                         <span>{route.routeNumber}</span>
//                     </div>
//                     <div className="info-item">
//                         <label>Operating Days</label>
//                         <span>{route.operatingDays?.join(', ')}</span>
//                     </div>
//                     <div className="info-item">
//                         <label>Total Distance</label>
//                         <span>{route.routeDetails?.totalDistance} km</span>
//                     </div>
//                     <div className="info-item">
//                         <label>Duration</label>
//                         <span>{route.routeDetails?.estimatedDuration?.hours}h {route.routeDetails?.estimatedDuration?.minutes}m</span>
//                     </div>
//                 </div>

//                 {/* Origin */}
//                 <div className="location-section origin">
//                     <h4>Origin</h4>
//                     <div className="location-info">
//                         <div className="loc-item">
//                             <label>City</label>
//                             <span>{route.origin?.city}</span>
//                         </div>
//                         <div className="loc-item">
//                             <label>State</label>
//                             <span>{route.origin?.state}</span>
//                         </div>
//                         <div className="loc-item">
//                             <label>Terminal</label>
//                             <span>{route.origin?.terminal}</span>
//                         </div>
//                         <div className="loc-item full-width">
//                             <label>Address</label>
//                             <span>{route.origin?.address}</span>
//                         </div>
//                     </div>
//                     <div className="timings-section">
//                         <label>Departure Times {isMultiTrip ? '(Multi-Trip)' : ''}</label>
//                         {renderTimings(route.origin?.timings)}
//                         {!isMultiTrip && route.origin?.departureTime && (
//                             <div className="timing-item">
//                                 {TimeDisplay({ time: route.origin.departureTime })}
//                             </div>
//                         )}
//                     </div>
//                 </div>

//                 {/* Destination */}
//                 <div className="location-section destination">
//                     <h4>Destination</h4>
//                     <div className="location-info">
//                         <div className="loc-item">
//                             <label>City</label>
//                             <span>{route.destination?.city}</span>
//                         </div>
//                         <div className="loc-item">
//                             <label>State</label>
//                             <span>{route.destination?.state}</span>
//                         </div>
//                         <div className="loc-item">
//                             <label>Terminal</label>
//                             <span>{route.destination?.terminal}</span>
//                         </div>
//                         <div className="loc-item full-width">
//                             <label>Address</label>
//                             <span>{route.destination?.address}</span>
//                         </div>
//                         <div className="loc-item">
//                             <label>Distance from Origin</label>
//                             <span>{route.destination?.distanceFromOrigin} km</span>
//                         </div>
//                     </div>
//                     <div className="timings-section">
//                         <label>Arrival Times {isMultiTrip ? '(Multi-Trip)' : ''}</label>
//                         {renderTimings(route.destination?.timings)}
//                         {!isMultiTrip && route.destination?.arrivalTime && (
//                             <div className="timing-item">
//                                 {TimeDisplay({ time: route.destination.arrivalTime })}
//                             </div>
//                         )}
//                     </div>
//                 </div>

//                 {/* Intermediate Stops */}
//                 {route.intermediateStops && route.intermediateStops.length > 0 && (
//                     <div className="stops-section">
//                         <h4>Intermediate Stops ({route.intermediateStops.length})</h4>
//                         <div className="stops-list">
//                             {route.intermediateStops.map((stop, idx) => (
//                                 <div key={stop._id || idx} className="stop-card">
//                                     <div className="stop-header">
//                                         <span className="stop-number">#{stop.sequence}</span>
//                                         <span className="stop-name">{stop.city}</span>
//                                         <StopTypeBadge type={stop.stopType} />
//                                         <StatusBadge isActive={stop.isEnabled !== false} />
//                                         <button 
//                                             className="btn btn-sm btn-toggle"
//                                             onClick={() => handleToggleStop(route.routeId, stop._id, !stop.isEnabled)}
//                                         >
//                                             {stop.isEnabled ? 'Disable' : 'Enable'}
//                                         </button>
//                                     </div>
//                                     <div className="stop-details">
//                                         <div className="detail-item">
//                                             <label>Distance</label>
//                                             <span>{stop.distanceFromOrigin || 0} km</span>
//                                         </div>
//                                         <div className="detail-item">
//                                             <label>Terminal</label>
//                                             <span>{stop.terminal}</span>
//                                         </div>
//                                         <div className="detail-item full-width">
//                                             <label>Address</label>
//                                             <span>{stop.address}</span>
//                                         </div>
//                                         <div className="detail-item full-width">
//                                             <label>Timings</label>
//                                             <div className="stop-timings">
//                                                 {renderStopTimings(stop)}
//                                             </div>
//                                         </div>
//                                     </div>
//                                 </div>
//                             ))}
//                         </div>
//                     </div>
//                 )}

//                 {/* Additional Boarding Points */}
//                 {route.additionalBoardingPoints && route.additionalBoardingPoints.length > 0 && (
//                     <div className="points-section boarding">
//                         <h4>Additional Boarding Points ({route.additionalBoardingPoints.length})</h4>
//                         <div className="points-list">
//                             {route.additionalBoardingPoints.map((point, idx) => (
//                                 <div key={point._id || idx} className="point-card">
//                                     <div className="point-header">
//                                         <span className="point-name">{point.name || point.city}</span>
//                                         <StatusBadge isActive={point.isEnabled !== false} />
//                                         <button 
//                                             className="btn btn-sm btn-toggle"
//                                             onClick={() => handleToggleBoardingPoint(route.routeId, point._id, !point.isEnabled)}
//                                         >
//                                             {point.isEnabled ? 'Disable' : 'Enable'}
//                                         </button>
//                                         {point.dateOverrides && point.dateOverrides.length > 0 && (
//                                             <button 
//                                                 className="btn btn-sm btn-info"
//                                                 onClick={() => handleViewDisabledDates(point._id)}
//                                             >
//                                                 View Overrides
//                                             </button>
//                                         )}
//                                     </div>
//                                     <div className="point-details">
//                                         <div className="detail-item">
//                                             <label>City</label>
//                                             <span>{point.city}</span>
//                                         </div>
//                                         <div className="detail-item">
//                                             <label>Pickup Time</label>
//                                             <span>{TimeDisplay({ time: point.pickupTime })}</span>
//                                         </div>
//                                         {point.timings && point.timings.length > 0 && (
//                                             <div className="detail-item full-width">
//                                                 <label>Timings</label>
//                                                 <div className="timings-list">
//                                                     {point.timings.map(t => (
//                                                         <div key={t.timeSlotSequence} className="timing-item">
//                                                             Trip {t.timeSlotSequence}: {TimeDisplay({ time: t.pickupTime })}
//                                                         </div>
//                                                     ))}
//                                                 </div>
//                                             </div>
//                                         )}
//                                     </div>
//                                 </div>
//                             ))}
//                         </div>
//                     </div>
//                 )}

//                 {/* Additional Dropping Points */}
//                 {route.additionalDroppingPoints && route.additionalDroppingPoints.length > 0 && (
//                     <div className="points-section dropping">
//                         <h4>Additional Dropping Points ({route.additionalDroppingPoints.length})</h4>
//                         <div className="points-list">
//                             {route.additionalDroppingPoints.map((point, idx) => (
//                                 <div key={point._id || idx} className="point-card">
//                                     <div className="point-header">
//                                         <span className="point-name">{point.name || point.city}</span>
//                                         <StatusBadge isActive={point.isEnabled !== false} />
//                                         <button 
//                                             className="btn btn-sm btn-toggle"
//                                             onClick={() => handleToggleDroppingPoint(route.routeId, point._id, !point.isEnabled)}
//                                         >
//                                             {point.isEnabled ? 'Disable' : 'Enable'}
//                                         </button>
//                                         {point.dateOverrides && point.dateOverrides.length > 0 && (
//                                             <button 
//                                                 className="btn btn-sm btn-info"
//                                                 onClick={() => handleViewDisabledDates(point._id)}
//                                             >
//                                                 View Overrides
//                                             </button>
//                                         )}
//                                     </div>
//                                     <div className="point-details">
//                                         <div className="detail-item">
//                                             <label>City</label>
//                                             <span>{point.city}</span>
//                                         </div>
//                                         <div className="detail-item">
//                                             <label>Drop Time</label>
//                                             <span>{TimeDisplay({ time: point.dropTime })}</span>
//                                         </div>
//                                         {point.timings && point.timings.length > 0 && (
//                                             <div className="detail-item full-width">
//                                                 <label>Timings</label>
//                                                 <div className="timings-list">
//                                                     {point.timings.map(t => (
//                                                         <div key={t.timeSlotSequence} className="timing-item">
//                                                             Trip {t.timeSlotSequence}: {TimeDisplay({ time: t.dropTime })}
//                                                         </div>
//                                                     ))}
//                                                 </div>
//                                             </div>
//                                         )}
//                                     </div>
//                                 </div>
//                             ))}
//                         </div>
//                     </div>
//                 )}
//             </div>
//         );
//     };

//     if (loading && schedules.length === 0) {
//         return <SkeletonLoader />;
//     }

//     return (
//         <div className="brs-container">
//             <div className="brs-header">
//                 <div className="header-left">
//                     <h1>Bus Route Schedule Management</h1>
//                 </div>
//                 <div className="header-right">
//                     <div className="search-wrapper">
//                         <input
//                             type="text"
//                             placeholder="Search by bus name, number or route..."
//                             className="search-input"
//                             value={searchTerm}
//                             onChange={handleSearch}
//                         />
//                     </div>
//                     <button className="btn btn-refresh" onClick={fetchSchedules}>
//                         ↻ Refresh
//                     </button>
//                 </div>
//             </div>

//             {/* Stats Cards */}
//             <div className="stats-cards">
//                 <div className="stat-card">
//                     <h3>Total Buses</h3>
//                     <p>{stats.total || 0}</p>
//                     <span>With route schedules</span>
//                 </div>
//                 <div className="stat-card">
//                     <h3>With Schedules</h3>
//                     <p>{stats.withSchedules || 0}</p>
//                     <span>Buses having route assigned</span>
//                 </div>
//                 <div className="stat-card">
//                     <h3>Active</h3>
//                     <p>{stats.active || 0}</p>
//                     <span>Currently active</span>
//                 </div>
//                 <div className="stat-card">
//                     <h3>Total Routes</h3>
//                     <p>{schedules.reduce((acc, s) => acc + (s.summary?.numberOfRoutes || 0), 0)}</p>
//                     <span>Across all buses</span>
//                 </div>
//             </div>

//             {/* Filter Bar */}
//             <div className="filter-bar">
//                 <select
//                     className="filter-select"
//                     value={filters.status}
//                     onChange={(e) => handleFilterChange('status', e.target.value)}
//                 >
//                     <option value="">All Status</option>
//                     <option value="true">Active</option>
//                     <option value="false">Inactive</option>
//                 </select>

//                 <select
//                     className="filter-select"
//                     value={filters.busType}
//                     onChange={(e) => handleFilterChange('busType', e.target.value)}
//                 >
//                     <option value="">All Bus Types</option>
//                     <option value="AC">AC</option>
//                     <option value="Non-AC">Non-AC</option>
//                     <option value="Sleeper">Sleeper</option>
//                     <option value="Seater">Seater</option>
//                 </select>

//                 <select
//                     className="filter-select"
//                     value={filters.routeType}
//                     onChange={(e) => handleFilterChange('routeType', e.target.value)}
//                 >
//                     <option value="">All Route Types</option>
//                     <option value="Round Trip">Round Trip</option>
//                     <option value="UP">One Way (UP)</option>
//                     <option value="DOWN">One Way (DOWN)</option>
//                 </select>
//             </div>

//             {/* Table */}
//             <div className="table-container">
//                 <table className="data-table">
//                     <thead>
//                         <tr>
//                             <th>No.</th>
//                             <th>Bus Name</th>
//                             <th>Bus Number</th>
//                             <th>Route</th>
//                             <th>Origin</th>
//                             <th>Destination</th>
//                             <th>Distance</th>
//                             <th>Stops</th>
//                             <th>Type</th>
//                             <th>Status</th>
//                             <th>Actions</th>
//                         </tr>
//                     </thead>
//                     <tbody>
//                         {schedules.length === 0 ? (
//                             <tr>
//                                 <td colSpan="11" className="empty-row">
//                                     No bus route schedules found
//                                 </td>
//                             </tr>
//                         ) : (
//                             schedules.map((item, index) => {
//                                 const busInfo = item.busInfo || {};
//                                 const summary = item.summary || {};

//                                 return (
//                                     <tr key={item._id || index}>
//                                         <td>{(currentPage - 1) * pageSize + index + 1}</td>
//                                         <td>
//                                             <div className="bus-name-cell">
//                                                 <strong>{busInfo.busName || 'N/A'}</strong>
//                                                 {busInfo.busClass && (
//                                                     <span className="bus-class-badge">{busInfo.busClass}</span>
//                                                 )}
//                                             </div>
//                                         </td>
//                                         <td>{busInfo.busNumber || 'N/A'}</td>
//                                         <td>
//                                             <div className="route-cell">
//                                                 {summary.routeNames?.length > 0 ? (
//                                                     <span className="route-name">{summary.routeNames.join(', ')}</span>
//                                                 ) : (
//                                                     <span className="no-route">No Route</span>
//                                                 )}
//                                             </div>
//                                         </td>
//                                         <td>{summary.origin || 'N/A'}</td>
//                                         <td>{summary.destination || 'N/A'}</td>
//                                         <td>{summary.totalDistance || 0} km</td>
//                                         <td>{summary.totalStops || 0}</td>
//                                         <td>
//                                             <span className={`route-type-badge ${summary.routeType?.includes('Round') ? 'roundtrip' : 'oneway'}`}>
//                                                 {summary.routeType || 'N/A'}
//                                             </span>
//                                         </td>
//                                         <td>
//                                             <StatusBadge isActive={item.isActive !== false} />
//                                         </td>
//                                         <td>
//                                             <div className="action-buttons">
//                                                 <button
//                                                     className="action-btn edit"
//                                                     onClick={() => handleEditSchedule(item)}
//                                                     disabled={!summary.routeNames?.length}
//                                                 >
//                                                     Edit
//                                                 </button>
//                                             </div>
//                                         </td>
//                                     </tr>
//                                 );
//                             })
//                         )}
//                     </tbody>
//                 </table>
//             </div>

//             {/* Pagination */}
//             {totalPages > 1 && (
//                 <div className="pagination-container">
//                     <div className="pagination-info">
//                         Showing {Math.min(pageSize, schedules.length)} of {totalItems} buses
//                         (Page {currentPage} of {totalPages})
//                     </div>
//                     <div className="pagination-controls">
//                         <button
//                             className="pagination-btn"
//                             onClick={() => setCurrentPage(prev => Math.max(1, prev - 1))}
//                             disabled={currentPage === 1}
//                         >
//                             Previous
//                         </button>
//                         <div className="page-numbers">
//                             {Array.from({ length: Math.min(5, totalPages) }, (_, i) => {
//                                 let pageNumber;
//                                 if (totalPages <= 5) {
//                                     pageNumber = i + 1;
//                                 } else if (currentPage <= 3) {
//                                     pageNumber = i + 1;
//                                 } else if (currentPage >= totalPages - 2) {
//                                     pageNumber = totalPages - 4 + i;
//                                 } else {
//                                     pageNumber = currentPage - 2 + i;
//                                 }
//                                 return (
//                                     <button
//                                         key={pageNumber}
//                                         className={`page-number ${pageNumber === currentPage ? 'active' : ''}`}
//                                         onClick={() => setCurrentPage(pageNumber)}
//                                     >
//                                         {pageNumber}
//                                     </button>
//                                 );
//                             })}
//                         </div>
//                         <button
//                             className="pagination-btn"
//                             onClick={() => setCurrentPage(prev => Math.min(totalPages, prev + 1))}
//                             disabled={currentPage === totalPages}
//                         >
//                             Next
//                         </button>
//                     </div>
//                 </div>
//             )}

//             {/* Edit Modal */}
//             {showEditModal && (
//                 <div className="modal-overlay" onClick={() => setShowEditModal(false)}>
//                     <div className="modal-content edit-modal-large" onClick={(e) => e.stopPropagation()}>
//                         <div className="modal-header">
//                             <h3>Edit Bus Route Schedule: {editingSchedule?.busInfo?.busName || 'Bus'}</h3>
//                             <button className="modal-close" onClick={() => setShowEditModal(false)}>×</button>
//                         </div>

//                         <div className="modal-body">
//                             {loadingSchedule ? (
//                                 <div className="loading-spinner">Loading schedule details...</div>
//                             ) : (
//                                 <>
//                                     {/* Bus Information */}
//                                     {renderEditBusInfo()}

//                                     {/* Route Tabs */}
//                                     <div className="route-tabs">
//                                         <button 
//                                             className={`tab-btn ${activeTab === 'UP' ? 'active' : ''}`}
//                                             onClick={() => setActiveTab('UP')}
//                                         >
//                                             UP Route
//                                             {upRoute && <span className="tab-badge">Active</span>}
//                                         </button>
//                                         <button 
//                                             className={`tab-btn ${activeTab === 'DOWN' ? 'active' : ''}`}
//                                             onClick={() => setActiveTab('DOWN')}
//                                         >
//                                             DOWN Route
//                                             {downRoute && <span className="tab-badge">Active</span>}
//                                         </button>
//                                         <button 
//                                             className={`tab-btn ${activeTab === 'ALL' ? 'active' : ''}`}
//                                             onClick={() => setActiveTab('ALL')}
//                                         >
//                                             All Stops & Points
//                                         </button>
//                                     </div>

//                                     {/* Route Content */}
//                                     <div className="route-content">
//                                         {activeTab === 'UP' && upRoute && renderRouteDetails(upRoute, 'UP')}
//                                         {activeTab === 'UP' && !upRoute && (
//                                             <div className="empty-route">
//                                                 <p>No UP route configured for this bus.</p>
//                                             </div>
//                                         )}

//                                         {activeTab === 'DOWN' && downRoute && renderRouteDetails(downRoute, 'DOWN')}
//                                         {activeTab === 'DOWN' && !downRoute && (
//                                             <div className="empty-route">
//                                                 <p>No DOWN route configured for this bus.</p>
//                                             </div>
//                                         )}

//                                         {activeTab === 'ALL' && (
//                                             <div className="all-stops-section">
//                                                 <div className="all-stops-grid">
//                                                     {upRoute && (
//                                                         <div className="route-column">
//                                                             <h3>UP Route</h3>
//                                                             {renderRouteDetails(upRoute, 'UP')}
//                                                         </div>
//                                                     )}
//                                                     {downRoute && (
//                                                         <div className="route-column">
//                                                             <h3>DOWN Route</h3>
//                                                             {renderRouteDetails(downRoute, 'DOWN')}
//                                                         </div>
//                                                     )}
//                                                 </div>
//                                             </div>
//                                         )}
//                                     </div>
//                                 </>
//                             )}
//                         </div>

//                         <div className="modal-footer">
//                             <button 
//                                 className="btn btn-secondary" 
//                                 onClick={() => setShowEditModal(false)}
//                             >
//                                 Cancel
//                             </button>
//                             <button 
//                                 className="btn btn-primary"
//                                 onClick={handleSaveChanges}
//                                 disabled={isUpdating || loadingSchedule}
//                             >
//                                 {isUpdating ? 'Saving...' : 'Save Changes'}
//                             </button>
//                         </div>
//                     </div>
//                 </div>
//             )}

//             {/* Disabled Dates Modal */}
//             {showDisabledDatesModal && (
//                 <div className="modal-overlay" onClick={() => setShowDisabledDatesModal(false)}>
//                     <div className="modal-content" onClick={(e) => e.stopPropagation()}>
//                         <div className="modal-header">
//                             <h3>Disabled Dates</h3>
//                             <button className="modal-close" onClick={() => setShowDisabledDatesModal(false)}>×</button>
//                         </div>
//                         <div className="modal-body">
//                             {disabledDates.length === 0 ? (
//                                 <p className="no-dates">No disabled dates found for this point.</p>
//                             ) : (
//                                 <div className="dates-list">
//                                     {disabledDates.map((item, idx) => (
//                                         <div key={idx} className="date-item">
//                                             <span className="date-value">
//                                                 {new Date(item.date).toLocaleDateString()}
//                                             </span>
//                                             <span className={`point-type ${item.pointType}`}>
//                                                 {item.pointType}
//                                             </span>
//                                             <span className="point-name">{item.pointName}</span>
//                                         </div>
//                                     ))}
//                                 </div>
//                             )}
//                         </div>
//                         <div className="modal-footer">
//                             <button className="btn btn-secondary" onClick={() => setShowDisabledDatesModal(false)}>
//                                 Close
//                             </button>
//                         </div>
//                     </div>
//                 </div>
//             )}
//         </div>
//     );
// };

// export default BusRouteScheduleManage;

// BusRouteScheduleManage.jsx
import React, { useState, useEffect, useRef } from 'react';
import { useSelector } from 'react-redux';
import { toast } from 'react-toastify';
import {
    getAllBusRouteSchedules,
    getBusRouteSchedule,
    updateBusRouteSchedule,
    getPointDisabledDates,
    getAllRoutes
} from '../../Services/Operations/ProductAPI';
import '../../Styles/BusRouteSchedule.css';

// Skeleton Components
const SkeletonStatsCard = () => (
    <div className="stat-card skeleton">
        <div className="skeleton-title"></div>
        <div className="skeleton-value"></div>
        <div className="skeleton-subtitle"></div>
    </div>
);

const SkeletonTableRow = () => (
    <tr className="skeleton-row">
        <td><div className="skeleton-cell"></div></td>
        <td><div className="skeleton-cell"></div></td>
        <td><div className="skeleton-cell"></div></td>
        <td><div className="skeleton-cell"></div></td>
        <td><div className="skeleton-cell"></div></td>
        <td><div className="skeleton-cell"></div></td>
        <td><div className="skeleton-cell"></div></td>
        <td><div className="skeleton-badge"></div></td>
        <td><div className="skeleton-actions"></div></td>
    </tr>
);

// Helper Components
const TimeDisplay = ({ time }) => {
    if (!time) return '--:--';
    if (time.includes(':')) {
        const [hours, minutes] = time.split(':');
        const hour = parseInt(hours);
        const ampm = hour >= 12 ? 'PM' : 'AM';
        const displayHour = hour % 12 || 12;
        return `${displayHour}:${minutes} ${ampm}`;
    }
    return time;
};

const StatusBadge = ({ isActive }) => (
    <span className={`status-badge ${isActive !== false ? 'active' : 'inactive'}`}>
        {isActive !== false ? 'Active' : 'Inactive'}
    </span>
);

const StopTypeBadge = ({ type }) => {
    const types = {
        boarding: { label: '🟢 Boarding', className: 'boarding' },
        dropping: { label: '🔴 Dropping', className: 'dropping' },
        both: { label: '🟡 Both', className: 'both' },
        none: { label: 'Pass-through', className: 'none' }
    };
    const info = types[type] || types.none;
    return <span className={`stop-type-badge ${info.className}`}>{info.label}</span>;
};

const TimePicker = ({ value, onChange, placeholder }) => (
    <div className="time-picker">
        <input
            type="time"
            value={value || ''}
            onChange={(e) => onChange(e.target.value)}
            className="edit-input"
            placeholder={placeholder}
        />
    </div>
);

const Checkbox = ({ label, checked, onChange }) => (
    <label className="checkbox-container">
        <input
            type="checkbox"
            checked={checked}
            onChange={onChange}
            className="checkbox-input"
        />
        <span className="checkbox-label">{label}</span>
    </label>
);

// Helper function to calculate manualDistFromPrev from distanceFromOrigin
const calculateManualDistFromPrev = (stops, index) => {
    if (!stops || stops.length === 0 || index < 0 || index >= stops.length) return '';
    
    const stop = stops[index];
    if (!stop) return '';
    
    // If manualDistFromPrev already exists, use it
    if (stop.manualDistFromPrev && parseFloat(stop.manualDistFromPrev) > 0) {
        return String(stop.manualDistFromPrev);
    }
    
    // Calculate from distanceFromOrigin
    if (stop.distanceFromOrigin && parseFloat(stop.distanceFromOrigin) > 0) {
        if (index === 0) {
            // First stop: distance from origin
            return String(stop.distanceFromOrigin);
        } else {
            const prevStop = stops[index - 1];
            if (prevStop && prevStop.distanceFromOrigin !== undefined) {
                const segmentDist = parseFloat((stop.distanceFromOrigin - prevStop.distanceFromOrigin).toFixed(1));
                if (segmentDist > 0) {
                    return String(segmentDist);
                }
            }
        }
    }
    
    // Default fallback
    return '';
};

// Helper function to calculate manualDistToNext from distanceFromOrigin
const calculateManualDistToNext = (stops, index) => {
    if (!stops || stops.length === 0 || index < 0 || index >= stops.length) return '';
    
    const stop = stops[index];
    if (!stop) return '';
    
    // If manualDistToNext already exists, use it
    if (stop.manualDistToNext && parseFloat(stop.manualDistToNext) > 0) {
        return String(stop.manualDistToNext);
    }
    
    // Calculate from distanceFromOrigin
    if (stop.distanceFromOrigin !== undefined && index < stops.length - 1) {
        const nextStop = stops[index + 1];
        if (nextStop && nextStop.distanceFromOrigin !== undefined) {
            const segmentDist = parseFloat((nextStop.distanceFromOrigin - stop.distanceFromOrigin).toFixed(1));
            if (segmentDist > 0) {
                return String(segmentDist);
            }
        }
    }
    
    return '';
};

const BusRouteScheduleManage = () => {
    const { token } = useSelector(state => state.user);

    const [loading, setLoading] = useState(true);
    const [schedules, setSchedules] = useState([]);
    const [searchTerm, setSearchTerm] = useState('');
    const [currentPage, setCurrentPage] = useState(1);
    const [totalPages, setTotalPages] = useState(1);
    const [totalItems, setTotalItems] = useState(0);
    const [pageSize] = useState(10);
    const [stats, setStats] = useState({
        total: 0,
        active: 0,
        inactive: 0,
        withSchedules: 0,
        withoutSchedules: 0
    });
    // Add this with other state declarations
const [refreshKey, setRefreshKey] = useState(0);
// Add this with other state declarations
const [currentUpRoute, setCurrentUpRoute] = useState(null);
const [currentDownRoute, setCurrentDownRoute] = useState(null);
    // Filters
    const [filterStatus, setFilterStatus] = useState('');
    const [filterBusType, setFilterBusType] = useState('');
    const [filterRouteType, setFilterRouteType] = useState('');

    // Edit Modal States
    const [showEditModal, setShowEditModal] = useState(false);
    const [editingSchedule, setEditingSchedule] = useState(null);
    const [scheduleData, setScheduleData] = useState(null);
    const [editForm, setEditForm] = useState({});
    const [isUpdating, setIsUpdating] = useState(false);
    const [activeRouteTab, setActiveRouteTab] = useState('UP');
    const [loadingSchedule, setLoadingSchedule] = useState(false);
    const [availableRoutes, setAvailableRoutes] = useState([]);
    const [loadingRoutes, setLoadingRoutes] = useState(false);

    // Disabled Dates Modal
    const [showDisabledDatesModal, setShowDisabledDatesModal] = useState(false);
    const [disabledDates, setDisabledDates] = useState([]);

    // Stop Edit Modal States
    const [showStopEditModal, setShowStopEditModal] = useState(false);
    const [editingStopData, setEditingStopData] = useState(null);
    const [stopEditForm, setStopEditForm] = useState({
        city: '',
        state: '',
        address: '',
        terminal: '',
        timings: [],
        stopType: 'none',
        distanceFromOrigin: 0,
        manualDistFromPrev: '',
        manualDistToNext: '',
        isManualStop: true,
        isBoarding: false,
        isDropping: false,
        routeId: '',
        direction: '',
        stopId: null,
        isNewStop: false,
        insertIndex: null
    });

    // Search timeout ref
    const searchTimeoutRef = useRef(null);

    // ========== AUTO-CALCULATE DURATION FOR UP ROUTE ==========
useEffect(() => {
    if (!editForm.routeSchedules) return;
    
    const upRoute = editForm.routeSchedules.find(r => r.direction === 'UP');
    if (!upRoute) return;
    
    // Get departure time - check both single and multi-trip formats
    let depTime = '';
    let arrTime = '';
    
    // Check if multi-trip (timings array exists)
    if (upRoute.origin?.timings && upRoute.origin.timings.length > 0) {
        // Get first trip departure time
        const firstTiming = upRoute.origin.timings[0];
        depTime = firstTiming?.departureTime || '';
    } else {
        depTime = upRoute.origin?.departureTime || '';
    }
    
    // Get arrival time - check both single and multi-trip formats
    if (upRoute.destination?.timings && upRoute.destination.timings.length > 0) {
        const firstTiming = upRoute.destination.timings[0];
        arrTime = firstTiming?.arrivalTime || '';
    } else {
        arrTime = upRoute.destination?.arrivalTime || '';
    }
    
    if (depTime && arrTime) {
        const [depHour, depMin] = depTime.split(':').map(Number);
        const [arrHour, arrMin] = arrTime.split(':').map(Number);
        
        if (!isNaN(depHour) && !isNaN(depMin) && !isNaN(arrHour) && !isNaN(arrMin)) {
            let depTotalMins = depHour * 60 + depMin;
            let arrTotalMins = arrHour * 60 + arrMin;
            
            // If arrival is before departure, add 24 hours (next day)
            if (arrTotalMins < depTotalMins) {
                arrTotalMins += 24 * 60;
            }
            
            const durationMins = arrTotalMins - depTotalMins;
            const hours = Math.floor(durationMins / 60);
            const minutes = durationMins % 60;
            
            // Update the routeDetails in editForm
            setEditForm(prev => {
                const routeSchedules = [...(prev.routeSchedules || [])];
                const upIndex = routeSchedules.findIndex(r => r.direction === 'UP');
                if (upIndex >= 0) {
                    const currentRoute = routeSchedules[upIndex];
                    routeSchedules[upIndex] = {
                        ...currentRoute,
                        routeDetails: {
                            ...(currentRoute.routeDetails || {}),
                            estimatedDuration: {
                                hours: hours,
                                minutes: minutes
                            }
                        }
                    };
                }
                return { ...prev, routeSchedules };
            });
        }
    }
}, [editForm.routeSchedules]);

// ========== AUTO-CALCULATE DURATION FOR DOWN ROUTE ==========
useEffect(() => {
    if (!editForm.routeSchedules) return;
    
    const downRoute = editForm.routeSchedules.find(r => r.direction === 'DOWN');
    if (!downRoute) return;
    
    // Get departure time - check both single and multi-trip formats
    let depTime = '';
    let arrTime = '';
    
    // Check if multi-trip (timings array exists)
    if (downRoute.origin?.timings && downRoute.origin.timings.length > 0) {
        const firstTiming = downRoute.origin.timings[0];
        depTime = firstTiming?.departureTime || '';
    } else {
        depTime = downRoute.origin?.departureTime || '';
    }
    
    // Get arrival time - check both single and multi-trip formats
    if (downRoute.destination?.timings && downRoute.destination.timings.length > 0) {
        const firstTiming = downRoute.destination.timings[0];
        arrTime = firstTiming?.arrivalTime || '';
    } else {
        arrTime = downRoute.destination?.arrivalTime || '';
    }
    
    if (depTime && arrTime) {
        const [depHour, depMin] = depTime.split(':').map(Number);
        const [arrHour, arrMin] = arrTime.split(':').map(Number);
        
        if (!isNaN(depHour) && !isNaN(depMin) && !isNaN(arrHour) && !isNaN(arrMin)) {
            let depTotalMins = depHour * 60 + depMin;
            let arrTotalMins = arrHour * 60 + arrMin;
            
            // If arrival is before departure, add 24 hours (next day)
            if (arrTotalMins < depTotalMins) {
                arrTotalMins += 24 * 60;
            }
            
            const durationMins = arrTotalMins - depTotalMins;
            const hours = Math.floor(durationMins / 60);
            const minutes = durationMins % 60;
            
            // Update the routeDetails in editForm
            setEditForm(prev => {
                const routeSchedules = [...(prev.routeSchedules || [])];
                const downIndex = routeSchedules.findIndex(r => r.direction === 'DOWN');
                if (downIndex >= 0) {
                    const currentRoute = routeSchedules[downIndex];
                    routeSchedules[downIndex] = {
                        ...currentRoute,
                        routeDetails: {
                            ...(currentRoute.routeDetails || {}),
                            estimatedDuration: {
                                hours: hours,
                                minutes: minutes
                            }
                        }
                    };
                }
                return { ...prev, routeSchedules };
            });
        }
    }
}, [editForm.routeSchedules]);

    // Fetch bus route schedules
    useEffect(() => {
        fetchSchedules();
    }, [currentPage, filterStatus, filterBusType, filterRouteType]);

    const fetchSchedules = async () => {
        try {
            setLoading(true);
            const response = await getAllBusRouteSchedules(
                token,
                currentPage,
                pageSize,
                searchTerm,
                {
                    status: filterStatus,
                    busType: filterBusType,
                    routeType: filterRouteType
                }
            );

            if (response && response.success) {
                setSchedules(response.data.schedules || []);
                setTotalPages(response.data.pagination?.totalPages || 1);
                setTotalItems(response.data.pagination?.totalItems || 0);
                setStats(response.data.stats || {
                    total: 0,
                    active: 0,
                    inactive: 0,
                    withSchedules: 0,
                    withoutSchedules: 0
                });
            } else {
                toast.error(response.message || 'Failed to fetch bus schedules');
            }
        } catch (error) {
            console.error('Error fetching schedules:', error);
            toast.error(error.message || 'Failed to fetch bus schedules');
        } finally {
            setLoading(false);
        }
    };

    const fetchAvailableRoutes = async () => {
        try {
            setLoadingRoutes(true);
            const response = await getAllRoutes(token, 1, 100, '');
            if (response && response.success) {
                const routes = response.data?.routes || [];
                setAvailableRoutes(routes);
            }
        } catch (error) {
            console.error('Error fetching routes:', error);
        } finally {
            setLoadingRoutes(false);
        }
    };

    const handleSearch = (e) => {
        const value = e.target.value;
        setSearchTerm(value);
        setCurrentPage(1);

        if (searchTimeoutRef.current) {
            clearTimeout(searchTimeoutRef.current);
        }
        searchTimeoutRef.current = setTimeout(() => {
            fetchSchedules();
        }, 500);
    };

    const handleFilterChange = (filterType, value) => {
        if (filterType === 'status') setFilterStatus(value);
        else if (filterType === 'busType') setFilterBusType(value);
        else if (filterType === 'routeType') setFilterRouteType(value);
        setCurrentPage(1);
    };

const handleEditSchedule = async (schedule) => {
    try {
        setLoadingSchedule(true);
        setEditingSchedule(schedule);

        const busId = schedule.busId?._id || schedule.busId;

        await fetchAvailableRoutes();

        const response = await getBusRouteSchedule(busId, token);

        if (response.success) {
            const data = response.data;
            setScheduleData(data);
            setEditForm(data);
            
            // ========== FIX: Set current route data ==========
            const upRouteData = data.routeSchedules?.find(r => r.direction === 'UP');
            const downRouteData = data.routeSchedules?.find(r => r.direction === 'DOWN');
            setCurrentUpRoute(upRouteData || null);
            setCurrentDownRoute(downRouteData || null);
            
            setShowEditModal(true);
            setActiveRouteTab('UP');
        } else {
            toast.error('Failed to fetch schedule details');
        }
    } catch (error) {
        console.error('Error fetching schedule:', error);
        toast.error(error.message || 'Failed to fetch schedule details');
    } finally {
        setLoadingSchedule(false);
    }
};

// Save changes - Calls API with all accumulated changes
// const handleSaveChanges = async () => {
//     try {
//         setIsUpdating(true);

//         const busId = editingSchedule.busId?._id || editingSchedule.busId;

//         // ========== Clean up temporary IDs before sending to API ==========
//         const cleanedRouteSchedules = (editForm.routeSchedules || []).map(route => ({
//             ...route,
//             intermediateStops: (route.intermediateStops || []).map(stop => {
//                 // If it's a temporary stop (has temp_ in _id), remove _id so API creates new one
//                 const { _id, ...rest } = stop;
//                 if (_id && typeof _id === 'string' && _id.startsWith('temp_')) {
//                     return rest;
//                 }
//                 return stop;
//             })
//         }));

//         const updatePayload = {
//             busInfo: {
//                 busName: editForm.busInfo?.busName || '',
//                 busNumber: editForm.busInfo?.busNumber || '',
//                 busType: editForm.busInfo?.busType || '',
//                 busCategory: editForm.busInfo?.busCategory || '',
//                 busClass: editForm.busInfo?.busClass || 'Standard',
//                 totalSeats: parseInt(editForm.busInfo?.totalSeats) || 0,
//                 availableSeats: parseInt(editForm.busInfo?.availableSeats) || 0,
//                 amenities: editForm.busInfo?.amenities || [],
//                 images: editForm.busInfo?.images || []
//             },
//             isActive: editForm.isActive !== false,
//             routeSchedules: cleanedRouteSchedules
//         };

//         console.log("Saving to API with payload:", updatePayload);

//         const response = await updateBusRouteSchedule(busId, updatePayload, token);

//         if (response.success) {
//             toast.success('Schedule updated successfully!');
//             setShowEditModal(false);
            
//             // Refresh data from API to get the latest with real IDs
//             const refreshResponse = await getBusRouteSchedule(busId, token);
//             if (refreshResponse.success) {
//                 const updatedData = refreshResponse.data;
//                 setScheduleData(updatedData);
//                 setEditForm(updatedData);
                
//                 const upRouteData = updatedData.routeSchedules?.find(r => r.direction === 'UP');
//                 const downRouteData = updatedData.routeSchedules?.find(r => r.direction === 'DOWN');
//                 setCurrentUpRoute(upRouteData || null);
//                 setCurrentDownRoute(downRouteData || null);
//                 setRefreshKey(prev => prev + 1);
//             }
            
//             fetchSchedules();
//         } else {
//             toast.error(response.message || 'Failed to update schedule');
//         }
//     } catch (error) {
//         console.error('Error updating schedule:', error);
//         toast.error(error.message || 'Failed to update schedule');
//     } finally {
//         setIsUpdating(false);
//     }
// };

const handleSaveChanges = async () => {
    try {
        setIsUpdating(true);

        const busId = editingSchedule.busId?._id || editingSchedule.busId;

        // ========== Clean up temporary IDs before sending to API ==========
        const cleanedRouteSchedules = (editForm.routeSchedules || []).map(route => ({
            ...route,
            // Ensure additionalBoardingPoints has origin point
            additionalBoardingPoints: ensureOriginBoardingPoint(route),
            // Ensure additionalDroppingPoints has destination point
            additionalDroppingPoints: ensureDestinationDroppingPoint(route),
            intermediateStops: (route.intermediateStops || []).map(stop => {
                const { _id, ...rest } = stop;
                if (_id && typeof _id === 'string' && _id.startsWith('temp_')) {
                    return rest;
                }
                return stop;
            })
        }));

        const updatePayload = {
            busInfo: {
                busName: editForm.busInfo?.busName || '',
                busNumber: editForm.busInfo?.busNumber || '',
                busType: editForm.busInfo?.busType || '',
                busCategory: editForm.busInfo?.busCategory || '',
                busClass: editForm.busInfo?.busClass || 'Standard',
                totalSeats: parseInt(editForm.busInfo?.totalSeats) || 0,
                availableSeats: parseInt(editForm.busInfo?.availableSeats) || 0,
                amenities: editForm.busInfo?.amenities || [],
                images: editForm.busInfo?.images || []
            },
            isActive: editForm.isActive !== false,
            routeSchedules: cleanedRouteSchedules
        };

        console.log("Saving to API with payload:", updatePayload);

        const response = await updateBusRouteSchedule(busId, updatePayload, token);

        if (response.success) {
            toast.success('Schedule updated successfully!');
            setShowEditModal(false);
            
            const refreshResponse = await getBusRouteSchedule(busId, token);
            if (refreshResponse.success) {
                const updatedData = refreshResponse.data;
                setScheduleData(updatedData);
                setEditForm(updatedData);
                
                const upRouteData = updatedData.routeSchedules?.find(r => r.direction === 'UP');
                const downRouteData = updatedData.routeSchedules?.find(r => r.direction === 'DOWN');
                setCurrentUpRoute(upRouteData || null);
                setCurrentDownRoute(downRouteData || null);
                setRefreshKey(prev => prev + 1);
            }
            
            fetchSchedules();
        } else {
            toast.error(response.message || 'Failed to update schedule');
        }
    } catch (error) {
        console.error('Error updating schedule:', error);
        toast.error(error.message || 'Failed to update schedule');
    } finally {
        setIsUpdating(false);
    }
};

// ========== HELPER: Ensure origin boarding point exists ==========
// const ensureOriginBoardingPoint = (route) => {
//     const boardingPoints = [...(route.additionalBoardingPoints || [])];
    
//     // Check if origin boarding point already exists
//     const originExists = boardingPoints.some(p => p.isOrigin === true || p._id === 'origin');
    
//     if (!originExists && route.origin) {
//         // Create origin boarding point
//         boardingPoints.unshift({
//             name: route.origin.terminal || route.origin.city,
//             address: route.origin.address || '',
//             city: route.origin.city || '',
//             state: route.origin.state || '',
//             landmark: route.origin.terminal || route.origin.city,
//             pickupTime: route.origin.departureTime || '',
//             timings: route.origin.timings || [],
//             isEnabled: true,
//             isOrigin: true,
//             dateOverrides: [],
//             _id: 'origin'
//         });
//     }
    
//     return boardingPoints;
// };

const ensureOriginBoardingPoint = (route) => {
    const boardingPoints = [...(route.additionalBoardingPoints || [])];
    
    // Check if origin boarding point already exists
    const originExists = boardingPoints.some(p => p.isOrigin === true);
    
    if (!originExists && route.origin) {
        const originTimings = route.origin.timings || [];
        const firstTiming = originTimings[0] || { departureTime: '' };
        
        boardingPoints.unshift({
            name: route.origin.terminal || route.origin.city,
            address: route.origin.address || '',
            city: route.origin.city || '',
            state: route.origin.state || '',
            landmark: route.origin.terminal || route.origin.city,
            pickupTime: firstTiming.departureTime || route.origin.departureTime || '',
            // ✅ FIX: Include timings array
            timings: originTimings.map(t => ({
                timeSlotSequence: t.timeSlotSequence || 1,
                pickupTime: t.departureTime || ''
            })),
            isEnabled: true,
            isOrigin: true,
            dateOverrides: []
        });
    }
    
    // Also clean up any existing origin point with string _id
    return boardingPoints.map(point => {
        if (point._id === 'origin' || point._id === 'destination') {
            const { _id, ...rest } = point;
            return rest;
        }
        return point;
    });
};

// ========== HELPER: Ensure destination dropping point exists ==========
// const ensureDestinationDroppingPoint = (route) => {
//     const droppingPoints = [...(route.additionalDroppingPoints || [])];
    
//     // Check if destination dropping point already exists
//     const destExists = droppingPoints.some(p => p.isDestination === true || p._id === 'destination');
    
//     if (!destExists && route.destination) {
//         // Create destination dropping point
//         droppingPoints.push({
//             name: route.destination.terminal || route.destination.city,
//             address: route.destination.address || '',
//             city: route.destination.city || '',
//             state: route.destination.state || '',
//             landmark: route.destination.terminal || route.destination.city,
//             dropTime: route.destination.arrivalTime || '',
//             timings: route.destination.timings || [],
//             isEnabled: true,
//             isDestination: true,
//             dateOverrides: [],
//             _id: 'destination'
//         });
//     }
    
//     return droppingPoints;
// };

const ensureDestinationDroppingPoint = (route) => {
    const droppingPoints = [...(route.additionalDroppingPoints || [])];
    
    // Check if destination dropping point already exists
    const destExists = droppingPoints.some(p => p.isDestination === true);
    
    if (!destExists && route.destination) {
        const destTimings = route.destination.timings || [];
        const firstTiming = destTimings[0] || { arrivalTime: '' };
        
        droppingPoints.push({
            name: route.destination.terminal || route.destination.city,
            address: route.destination.address || '',
            city: route.destination.city || '',
            state: route.destination.state || '',
            landmark: route.destination.terminal || route.destination.city,
            dropTime: firstTiming.arrivalTime || route.destination.arrivalTime || '',
            // ✅ FIX: Include timings array
            timings: destTimings.map(t => ({
                timeSlotSequence: t.timeSlotSequence || 1,
                dropTime: t.arrivalTime || ''
            })),
            isEnabled: true,
            isDestination: true,
            dateOverrides: []
        });
    }
    
    // Also clean up any existing destination point with string _id
    return droppingPoints.map(point => {
        if (point._id === 'origin' || point._id === 'destination') {
            const { _id, ...rest } = point;
            return rest;
        }
        return point;
    });
};

const handleToggleStop = async (routeId, stopId, enabled) => {
    try {
        const busId = editingSchedule.busId?._id || editingSchedule.busId;
        const response = await updateBusRouteSchedule(busId, {
            toggleStop: { routeId, stopId, enabled }
        }, token);

        if (response.success) {
            toast.success(`Stop ${enabled ? 'enabled' : 'disabled'} successfully`);
            const refreshResponse = await getBusRouteSchedule(busId, token);
            if (refreshResponse.success) {
                const updatedData = refreshResponse.data;
                setScheduleData(updatedData);
                setEditForm(updatedData);
                
                // Update current route data
                const upRouteData = updatedData.routeSchedules?.find(r => r.direction === 'UP');
                const downRouteData = updatedData.routeSchedules?.find(r => r.direction === 'DOWN');
                setCurrentUpRoute(upRouteData || null);
                setCurrentDownRoute(downRouteData || null);
                
                setRefreshKey(prev => prev + 1);
            }
        }
    } catch (error) {
        console.error('Error toggling stop:', error);
        toast.error('Failed to update stop');
    }
};

    // Toggle boarding point
    const handleToggleBoardingPoint = async (routeId, pointId, enabled) => {
        try {
            const busId = editingSchedule.busId?._id || editingSchedule.busId;
            const response = await updateBusRouteSchedule(busId, {
                toggleBoardingPoint: { routeId, pointId, enabled }
            }, token);

            if (response.success) {
                toast.success(`Boarding point ${enabled ? 'enabled' : 'disabled'} successfully`);
                const refreshResponse = await getBusRouteSchedule(busId, token);
                if (refreshResponse.success) {
                    setScheduleData(refreshResponse.data);
                    setEditForm(refreshResponse.data);
                }
            }
        } catch (error) {
            console.error('Error toggling boarding point:', error);
            toast.error('Failed to update boarding point');
        }
    };

    // Toggle dropping point
    const handleToggleDroppingPoint = async (routeId, pointId, enabled) => {
        try {
            const busId = editingSchedule.busId?._id || editingSchedule.busId;
            const response = await updateBusRouteSchedule(busId, {
                toggleDroppingPoint: { routeId, pointId, enabled }
            }, token);

            if (response.success) {
                toast.success(`Dropping point ${enabled ? 'enabled' : 'disabled'} successfully`);
                const refreshResponse = await getBusRouteSchedule(busId, token);
                if (refreshResponse.success) {
                    setScheduleData(refreshResponse.data);
                    setEditForm(refreshResponse.data);
                }
            }
        } catch (error) {
            console.error('Error toggling dropping point:', error);
            toast.error('Failed to update dropping point');
        }
    };

    // View disabled dates
    const handleViewDisabledDates = async (pointId) => {
        try {
            const busId = editingSchedule.busId?._id || editingSchedule.busId;
            const response = await getPointDisabledDates(busId, pointId, token);
            if (response.success) {
                setDisabledDates(response.data);
                setShowDisabledDatesModal(true);
            }
        } catch (error) {
            console.error('Error fetching disabled dates:', error);
            toast.error('Failed to fetch disabled dates');
        }
    };

    const getRouteSchedule = (direction) => {
        if (!scheduleData?.routeSchedules) return null;
        return scheduleData.routeSchedules.find(r => r.direction === direction);
    };

    const upRoute = getRouteSchedule('UP');
    const downRoute = getRouteSchedule('DOWN');

    // Update route in editForm
    const updateRouteInEditForm = (direction, updatedRoute) => {
        setEditForm(prev => {
            const routeSchedules = prev.routeSchedules || [];
            const index = routeSchedules.findIndex(r => r.direction === direction);
            if (index >= 0) {
                routeSchedules[index] = { ...routeSchedules[index], ...updatedRoute };
            } else {
                routeSchedules.push({ direction, ...updatedRoute });
            }
            return { ...prev, routeSchedules };
        });
    };

    // ========== STOP EDIT MODAL HANDLERS ==========

// Open stop edit modal for editing
const handleOpenStopEdit = (routeId, direction, stopId) => {
    // ========== Get the latest route data from editForm ==========
    const route = direction === 'UP' ? 
        editForm.routeSchedules?.find(r => r.direction === 'UP') : 
        editForm.routeSchedules?.find(r => r.direction === 'DOWN');
    
    if (!route) {
        toast.error('Route not found');
        return;
    }
    
    const allStops = route?.intermediateStops || [];
    const stopIndex = allStops.findIndex(s => s._id === stopId);
    const stop = allStops[stopIndex];
    
    if (!stop) {
        toast.error('Stop not found');
        return;
    }

    // Calculate manualDistFromPrev from distanceFromOrigin
    const calculatedManualDist = calculateManualDistFromPrev(allStops, stopIndex);
    const calculatedManualToNext = calculateManualDistToNext(allStops, stopIndex);

    // ========== Preserve all timings properly ==========
    let stopTimings = [];
    if (stop.timings && stop.timings.length > 0) {
        // Use existing timings
        stopTimings = stop.timings.map(t => ({
            timeSlotSequence: t.timeSlotSequence || 1,
            arrivalTime: t.arrivalTime || '',
            departureTime: t.departureTime || t.arrivalTime || ''
        }));
    } else if (stop.arrivalTime || stop.departureTime) {
        // Legacy single-trip format - convert to timings array
        stopTimings = [{
            timeSlotSequence: 1,
            arrivalTime: stop.arrivalTime || '',
            departureTime: stop.departureTime || stop.arrivalTime || ''
        }];
    } else {
        // Default empty timing
        stopTimings = [{
            timeSlotSequence: 1,
            arrivalTime: '',
            departureTime: ''
        }];
    }

    // Sort timings by sequence
    stopTimings.sort((a, b) => (a.timeSlotSequence || 0) - (b.timeSlotSequence || 0));

    setEditingStopData(stop);
    setStopEditForm({
        city: stop.city || '',
        state: stop.state || '',
        address: stop.address || '',
        terminal: stop.terminal || '',
        timings: stopTimings,
        stopType: stop.stopType || 'none',
        distanceFromOrigin: stop.distanceFromOrigin || 0,
        manualDistFromPrev: calculatedManualDist,
        manualDistToNext: calculatedManualToNext,
        isManualStop: stop.isManualStop !== false,
        isBoarding: stop.stopType === 'boarding' || stop.stopType === 'both',
        isDropping: stop.stopType === 'dropping' || stop.stopType === 'both',
        routeId: routeId,
        direction: direction,
        stopId: stopId,
        isNewStop: false,
        insertIndex: null
    });
    setShowStopEditModal(true);
};

// Open stop edit modal for adding new stop
const handleOpenAddStop = (routeId, direction, insertIndex = null) => {
    const route = direction === 'UP' ? upRoute : downRoute;
    const allStops = route?.intermediateStops || [];
    
    // Determine the number of trips from the route
    const numberOfTrips = route?.origin?.timings?.length || 1;
    
    let defaultManualDist = '';
    let defaultDistanceFromOrigin = 0;
    
    if (insertIndex !== null && insertIndex > 0 && allStops[insertIndex - 1]) {
        const prevStop = allStops[insertIndex - 1];
        defaultDistanceFromOrigin = prevStop.distanceFromOrigin || 0;
        defaultManualDist = '5.0';
    } else if (insertIndex === 0) {
        defaultManualDist = '5.0';
    } else if (allStops.length > 0) {
        const lastStop = allStops[allStops.length - 1];
        defaultDistanceFromOrigin = lastStop.distanceFromOrigin || 0;
        defaultManualDist = '5.0';
    }

    // ========== FIX: Create timings for all trips ==========
    const defaultTimings = Array.from({ length: numberOfTrips }, (_, i) => ({
        timeSlotSequence: i + 1,
        arrivalTime: '',
        departureTime: ''
    }));

    setStopEditForm({
        city: '',
        state: '',
        address: '',
        terminal: '',
        timings: defaultTimings,  // Initialize timings for all trips
        stopType: 'none',
        distanceFromOrigin: defaultDistanceFromOrigin,
        manualDistFromPrev: defaultManualDist,
        manualDistToNext: '',
        isManualStop: true,
        isBoarding: false,
        isDropping: false,
        routeId: routeId,
        direction: direction,
        stopId: null,
        isNewStop: true,
        insertIndex: insertIndex
    });
    setShowStopEditModal(true);
};

// FIXED: Save stop from edit modal - updates stops AND boarding/dropping points
const handleSaveStopEdit = () => {
    // Validate required fields
    console.log("stopEditForm :::::::::: ", stopEditForm);
    
    if (!stopEditForm.city.trim()) {
        toast.error('City name is required');
        return;
    }

    // Check if at least one timing exists
    if (!stopEditForm.timings || stopEditForm.timings.length === 0) {
        toast.error('Please add at least one timing for this stop');
        return;
    }

    // Validate timings have arrival times
    const missingArrival = stopEditForm.timings.some(t => !t.arrivalTime);
    if (missingArrival) {
        toast.error('Please provide arrival time for all trips');
        return;
    }

    // For manual stops, validate distance
    if (stopEditForm.isManualStop && (!stopEditForm.manualDistFromPrev || parseFloat(stopEditForm.manualDistFromPrev) <= 0)) {
        toast.error('Please provide distance from previous stop');
        return;
    }

    // Determine stop type
    let stopType = 'none';
    if (stopEditForm.isBoarding && stopEditForm.isDropping) stopType = 'both';
    else if (stopEditForm.isBoarding) stopType = 'boarding';
    else if (stopEditForm.isDropping) stopType = 'dropping';

    // Ensure timings are properly formatted
    const formattedTimings = stopEditForm.timings.map((t, idx) => ({
        timeSlotSequence: t.timeSlotSequence || idx + 1,
        arrivalTime: t.arrivalTime || '',
        departureTime: t.departureTime || t.arrivalTime || ''
    }));

    // Sort timings by timeSlotSequence
    formattedTimings.sort((a, b) => (a.timeSlotSequence || 0) - (b.timeSlotSequence || 0));

    // Get first timing for top-level fields
    const firstTiming = formattedTimings[0] || { arrivalTime: '', departureTime: '' };

    const stopData = {
        city: stopEditForm.city.trim(),
        state: stopEditForm.state || '',
        address: stopEditForm.address || `${stopEditForm.city}, ${stopEditForm.state || 'India'}`,
        terminal: stopEditForm.terminal || `${stopEditForm.city} Bus Stand`,
        stopType: stopType,
        timings: formattedTimings,
        // Top-level fields from first timing
        arrivalTime: firstTiming.arrivalTime,
        departureTime: firstTiming.departureTime || firstTiming.arrivalTime,
        distanceFromOrigin: parseFloat(stopEditForm.distanceFromOrigin) || 0,
        manualDistFromPrev: stopEditForm.manualDistFromPrev ? parseFloat(stopEditForm.manualDistFromPrev) : null,
        manualDistToNext: stopEditForm.manualDistToNext ? parseFloat(stopEditForm.manualDistToNext) : null,
        isManualStop: stopEditForm.isManualStop,
        coordinates: stopEditForm.isManualStop ? { lat: 0, lng: 0 } : { lat: 0, lng: 0 },
        // Preserve the ID if editing
        _id: stopEditForm.stopId || undefined
    };

    // ========== UPDATE LOCAL STATE - INCLUDING BOARDING/DROPPING POINTS ==========
    const direction = stopEditForm.direction;
    
    // Get the current route from editForm
    const routeIndex = (editForm.routeSchedules || []).findIndex(r => r.direction === direction);
    
    if (routeIndex === -1) {
        toast.error('Route not found in edit form');
        return;
    }

    const currentRoute = editForm.routeSchedules[routeIndex];
    const updatedStops = [...(currentRoute.intermediateStops || [])];
    
    // Track the stop that was added/updated
    let updatedStop = null;
    
    if (stopEditForm.isNewStop) {
        // Add new stop
        const newStop = {
            ...stopData,
            _id: `temp_${Date.now()}_${Math.random().toString(36).substr(2, 9)}`,
            isEnabled: true,
            sequence: stopEditForm.insertIndex !== null ? stopEditForm.insertIndex + 1 : updatedStops.length + 1
        };
        
        if (stopEditForm.insertIndex !== null && stopEditForm.insertIndex >= 0) {
            updatedStops.splice(stopEditForm.insertIndex, 0, newStop);
        } else {
            updatedStops.push(newStop);
        }
        updatedStop = newStop;
    } else {
        // Update existing stop
        const stopIndex = updatedStops.findIndex(s => s._id === stopEditForm.stopId);
        if (stopIndex === -1) {
            toast.error('Stop not found in route');
            return;
        }
        // Preserve the original _id
        updatedStops[stopIndex] = { 
            ...updatedStops[stopIndex], 
            ...stopData,
            _id: stopEditForm.stopId // Keep the original ID
        };
        updatedStop = updatedStops[stopIndex];
    }

    // Re-sequence stops
    const reSequencedStops = updatedStops.map((stop, idx) => ({
        ...stop,
        sequence: idx + 1
    }));

    // ========== UPDATE BOARDING AND DROPPING POINTS ==========
    // We need to update the additionalBoardingPoints and additionalDroppingPoints
    // to reflect the new timings
    
    let updatedBoardingPoints = [...(currentRoute.additionalBoardingPoints || [])];
    let updatedDroppingPoints = [...(currentRoute.additionalDroppingPoints || [])];
    
    // Check if this stop already exists in boarding/dropping points
    const existingBoardingIndex = updatedBoardingPoints.findIndex(
        p => p.city === stopEditForm.city || p._id === stopEditForm.stopId
    );
    const existingDroppingIndex = updatedDroppingPoints.findIndex(
        p => p.city === stopEditForm.city || p._id === stopEditForm.stopId
    );
    
    // Prepare boarding point data from the updated stop
    const boardingPointData = {
        name: stopData.terminal || stopData.city,
        address: stopData.address || '',
        city: stopData.city || '',
        state: stopData.state || '',
        landmark: stopData.terminal || stopData.city,
        // Use the first timing for pickupTime
        pickupTime: firstTiming.departureTime || firstTiming.arrivalTime || '',
        // Include all timings
        timings: formattedTimings.map(t => ({
            timeSlotSequence: t.timeSlotSequence,
            pickupTime: t.departureTime || t.arrivalTime || ''
        })),
        isEnabled: true,
        dateOverrides: []
    };
    
    // Prepare dropping point data from the updated stop
    const droppingPointData = {
        name: stopData.terminal || stopData.city,
        address: stopData.address || '',
        city: stopData.city || '',
        state: stopData.state || '',
        landmark: stopData.terminal || stopData.city,
        // Use the first timing for dropTime
        dropTime: firstTiming.arrivalTime || firstTiming.departureTime || '',
        // Include all timings
        timings: formattedTimings.map(t => ({
            timeSlotSequence: t.timeSlotSequence,
            dropTime: t.arrivalTime || t.departureTime || ''
        })),
        isEnabled: true,
        dateOverrides: []
    };

    // Update boarding points based on stop type
    if (stopType === 'boarding' || stopType === 'both') {
        if (existingBoardingIndex >= 0) {
            // Update existing boarding point - preserve _id
            const existingId = updatedBoardingPoints[existingBoardingIndex]._id;
            updatedBoardingPoints[existingBoardingIndex] = {
                ...boardingPointData,
                _id: existingId
            };
        } else if (!stopEditForm.isNewStop) {
            // If editing existing stop and it wasn't in boarding points, add it
            updatedBoardingPoints.push({
                ...boardingPointData,
                _id: `temp_bp_${Date.now()}_${Math.random().toString(36).substr(2, 9)}`
            });
        } else {
            // New stop with boarding type
            updatedBoardingPoints.push({
                ...boardingPointData,
                _id: `temp_bp_${Date.now()}_${Math.random().toString(36).substr(2, 9)}`
            });
        }
    } else {
        // If stop type is not boarding or both, remove from boarding points
        if (existingBoardingIndex >= 0) {
            updatedBoardingPoints.splice(existingBoardingIndex, 1);
        }
    }

    // Update dropping points based on stop type
    if (stopType === 'dropping' || stopType === 'both') {
        if (existingDroppingIndex >= 0) {
            // Update existing dropping point - preserve _id
            const existingId = updatedDroppingPoints[existingDroppingIndex]._id;
            updatedDroppingPoints[existingDroppingIndex] = {
                ...droppingPointData,
                _id: existingId
            };
        } else if (!stopEditForm.isNewStop) {
            // If editing existing stop and it wasn't in dropping points, add it
            updatedDroppingPoints.push({
                ...droppingPointData,
                _id: `temp_dp_${Date.now()}_${Math.random().toString(36).substr(2, 9)}`
            });
        } else {
            // New stop with dropping type
            updatedDroppingPoints.push({
                ...droppingPointData,
                _id: `temp_dp_${Date.now()}_${Math.random().toString(36).substr(2, 9)}`
            });
        }
    } else {
        // If stop type is not dropping or both, remove from dropping points
        if (existingDroppingIndex >= 0) {
            updatedDroppingPoints.splice(existingDroppingIndex, 1);
        }
    }

    // ========== UPDATE THE ROUTE WITH ALL CHANGES ==========
    const updatedRoute = {
        ...currentRoute,
        intermediateStops: reSequencedStops,
        additionalBoardingPoints: updatedBoardingPoints,
        additionalDroppingPoints: updatedDroppingPoints
    };

    // ========== UPDATE ALL LOCAL STATE ==========
    // 1. Update editForm
    setEditForm(prev => {
        const routeSchedules = [...(prev.routeSchedules || [])];
        routeSchedules[routeIndex] = updatedRoute;
        return { ...prev, routeSchedules };
    });

    // 2. Update scheduleData
    setScheduleData(prev => {
        const routeSchedules = [...(prev?.routeSchedules || [])];
        const idx = routeSchedules.findIndex(r => r.direction === direction);
        if (idx >= 0) {
            routeSchedules[idx] = updatedRoute;
        }
        return { ...prev, routeSchedules };
    });

    // 3. Update current route state
    if (direction === 'UP') {
        setCurrentUpRoute(updatedRoute);
    } else {
        setCurrentDownRoute(updatedRoute);
    }

    // 4. Force re-render
    setRefreshKey(prev => prev + 1);

    // Close the modal
    setShowStopEditModal(false);
    
    // Show success message with timing info
    const timingInfo = formattedTimings.length > 1 
        ? `${formattedTimings.length} trips configured` 
        : `Time: ${firstTiming.arrivalTime}`;
    
    toast.success(
        stopEditForm.isNewStop 
            ? `Stop added locally. ${timingInfo}. Click "Save Changes" to save to server.` 
            : `Stop updated locally. ${timingInfo}. Click "Save Changes" to save to server.`
    );
};

    // Delete stop
    const handleDeleteStop = async (routeId, direction, stopId) => {
        if (!window.confirm('Are you sure you want to delete this stop?')) return;

        try {
            const busId = editingSchedule.busId?._id || editingSchedule.busId;
            const response = await updateBusRouteSchedule(busId, {
                deleteStop: {
                    routeId: routeId,
                    direction: direction,
                    stopId: stopId
                }
            }, token);

            if (response.success) {
                toast.success('Stop deleted successfully');
                const refreshResponse = await getBusRouteSchedule(busId, token);
                if (refreshResponse.success) {
                    setScheduleData(refreshResponse.data);
                    setEditForm(refreshResponse.data);
                }
            }
        } catch (error) {
            console.error('Error deleting stop:', error);
            toast.error('Failed to delete stop');
        }
    };

    // Delete boarding point
    const handleDeleteBoardingPoint = async (routeId, direction, pointId) => {
        if (!window.confirm('Are you sure you want to delete this boarding point?')) return;

        try {
            const busId = editingSchedule.busId?._id || editingSchedule.busId;
            const response = await updateBusRouteSchedule(busId, {
                deleteBoardingPoint: {
                    routeId: routeId,
                    direction: direction,
                    pointId: pointId
                }
            }, token);

            if (response.success) {
                toast.success('Boarding point deleted successfully');
                const refreshResponse = await getBusRouteSchedule(busId, token);
                if (refreshResponse.success) {
                    setScheduleData(refreshResponse.data);
                    setEditForm(refreshResponse.data);
                }
            }
        } catch (error) {
            console.error('Error deleting boarding point:', error);
            toast.error('Failed to delete boarding point');
        }
    };

    // Delete dropping point
    const handleDeleteDroppingPoint = async (routeId, direction, pointId) => {
        if (!window.confirm('Are you sure you want to delete this dropping point?')) return;

        try {
            const busId = editingSchedule.busId?._id || editingSchedule.busId;
            const response = await updateBusRouteSchedule(busId, {
                deleteDroppingPoint: {
                    routeId: routeId,
                    direction: direction,
                    pointId: pointId
                }
            }, token);

            if (response.success) {
                toast.success('Dropping point deleted successfully');
                const refreshResponse = await getBusRouteSchedule(busId, token);
                if (refreshResponse.success) {
                    setScheduleData(refreshResponse.data);
                    setEditForm(refreshResponse.data);
                }
            }
        } catch (error) {
            console.error('Error deleting dropping point:', error);
            toast.error('Failed to delete dropping point');
        }
    };

    // ========== RENDER FUNCTIONS ==========

    const renderEditableBusInfo = () => {
        const info = editForm.busInfo || {};

        return (
            <div className="bus-info-section editable">
                <div style={{
                    display: 'flex',
                    justifyContent: 'space-between',
                    alignItems: 'center',
                    marginBottom: '16px'
                }}>
                    <h3 style={{ margin: 0, fontSize: '20px', fontWeight: '600' }}>
                        {info.busName || 'Bus'}
                    </h3>
                    <StatusBadge isActive={editForm.isActive !== false} />
                </div>

                <div className="edit-form-grid">
                    <div className="form-group">
                        <label>Bus Name *</label>
                        <input
                            type="text"
                            value={info.busName || ''}
                            onChange={(e) => setEditForm(prev => ({
                                ...prev,
                                busInfo: { ...prev.busInfo, busName: e.target.value }
                            }))}
                            className="form-input"
                            placeholder="Enter bus name"
                        />
                    </div>

                    <div className="form-group">
                        <label>Bus Number *</label>
                        <input
                            type="text"
                            value={info.busNumber || ''}
                            onChange={(e) => setEditForm(prev => ({
                                ...prev,
                                busInfo: { ...prev.busInfo, busNumber: e.target.value }
                            }))}
                            className="form-input"
                            placeholder="e.g., WB 6S 9876"
                        />
                    </div>

                </div>

                <div className="form-group" style={{ marginTop: '12px' }}>
                    <label>Amenities (comma separated)</label>
                    <input
                        type="text"
                        value={(info.amenities || []).join(', ')}
                        onChange={(e) => {
                            const amenities = e.target.value.split(',').map(s => s.trim()).filter(Boolean);
                            setEditForm(prev => ({
                                ...prev,
                                busInfo: { ...prev.busInfo, amenities }
                            }));
                        }}
                        className="form-input"
                        placeholder="e.g., WiFi, AC, Charging Ports, TV"
                    />
                    <small className="helper-text">Separate amenities with commas</small>
                </div>
            </div>
        );
    };

// Render Intermediate Stops with inline insert buttons
const renderStopsWithInlineInsert = (route, direction, stops) => {
    // ========== FIX: Use the latest stops from editForm ==========
    const latestRoute = direction === 'UP' ? 
        editForm.routeSchedules?.find(r => r.direction === 'UP') : 
        editForm.routeSchedules?.find(r => r.direction === 'DOWN');
    
    // Use the latest data or fallback
    const routeData = latestRoute || route;
    const stopsToRender = routeData?.intermediateStops || stops || [];
    
    if (!stopsToRender || stopsToRender.length === 0) {
        return (
            <div className="stops-empty-state">
                <p>No intermediate stops added yet.</p>
                <button
                    className="btn btn-sm btn-add-stop"
                    onClick={() => handleOpenAddStop(routeData.routeId, direction)}
                >
                    + Add First Stop
                </button>
            </div>
        );
    }

    const renderInsertButton = (index) => (
        <div className="insert-stop-wrapper">
            <div className="insert-line"></div>
            <button
                className="insert-stop-btn"
                onClick={() => handleOpenAddStop(routeData.routeId, direction, index)}
            >
                <span className="insert-icon">+</span> Insert stop here
            </button>
            <div className="insert-line"></div>
        </div>
    );

    return (
        <div className="stops-list-container" key={`stops-${refreshKey}-${direction}`}>
            {renderInsertButton(0)}

            {stopsToRender.map((stop, index) => {
                // Calculate manualDistFromPrev for display
                const displayManualDist = calculateManualDistFromPrev(stopsToRender, index);
                const distanceDisplay = displayManualDist || 
                    (typeof stop.distanceFromOrigin === 'number' 
                        ? stop.distanceFromOrigin.toFixed(2) 
                        : parseFloat(stop.distanceFromOrigin || 0).toFixed(2));

                // ========== FIX: Ensure timings are properly displayed ==========
                const hasTimings = stop.timings && stop.timings.length > 0;

                return (
                    <React.Fragment key={stop._id || `stop-${index}-${refreshKey}`}>
                        <div className="stop-item-card">
                            <div className="stop-item-header">
                                <div className="stop-item-left">
                                    <span className="stop-item-number">{index + 1}.</span>
                                    <span className="stop-item-name">{stop.city}</span>
                                    <span className="stop-item-distance">
                                        ({distanceDisplay} km)
                                    </span>
                                    <StopTypeBadge type={stop.stopType} />
                                    <StatusBadge isActive={stop.isEnabled !== false} />
                                </div>
                                <div className="stop-item-actions">
                                    <button
                                        className="stop-action-btn edit"
                                        onClick={() => handleOpenStopEdit(routeData.routeId, direction, stop._id)}
                                    >
                                        Editing
                                    </button>
                                </div>
                            </div>

                            {/* ========== FIX: Display timings correctly ========== */}
                            {hasTimings ? (
                                <div className="stop-timings-grid">
                                    {stop.timings.map((timing, idx) => (
                                        <div key={`timing-${stop._id}-${timing.timeSlotSequence || idx}`} className="stop-timing-row">
                                            <span className="trip-badge">Trip {timing.timeSlotSequence || idx + 1}:</span>
                                            <span className="timing-arrival">Arr {TimeDisplay({ time: timing.arrivalTime })}</span>
                                            <span className="timing-arrow">→</span>
                                            <span className="timing-departure">Dep {TimeDisplay({ time: timing.departureTime })}</span>
                                        </div>
                                    ))}
                                </div>
                            ) : (stop.arrivalTime || stop.departureTime) ? (
                                <div className="stop-timing-row">
                                    <span className="timing-arrival">Arr {TimeDisplay({ time: stop.arrivalTime })}</span>
                                    <span className="timing-arrow">→</span>
                                    <span className="timing-departure">Dep {TimeDisplay({ time: stop.departureTime })}</span>
                                </div>
                            ) : (
                                <div className="stop-timing-row" style={{ color: '#999', fontStyle: 'italic' }}>
                                    No timings set
                                </div>
                            )}
                        </div>

                        {renderInsertButton(index + 1)}
                    </React.Fragment>
                );
            })}
        </div>
    );
};

// ========== TIMINGS SECTION IN STOP EDIT MODAL ==========
const renderStopEditModal = () => {
    if (!showStopEditModal) return null;

    const isEditing = !stopEditForm.isNewStop;
    const numberOfTrips = stopEditForm.timings?.length || 1;

const updateTiming = (index, field, value) => {
    setStopEditForm(prev => {
        const updatedTimings = [...(prev.timings || [])];
        if (!updatedTimings[index]) {
            updatedTimings[index] = {
                timeSlotSequence: index + 1,
                arrivalTime: '',
                departureTime: ''
            };
        }
        updatedTimings[index] = { ...updatedTimings[index], [field]: value };
        return { ...prev, timings: updatedTimings };
    });
};

const addTimingTrip = () => {
    setStopEditForm(prev => {
        const newIndex = (prev.timings || []).length;
        const newTiming = {
            timeSlotSequence: newIndex + 1,
            arrivalTime: '',
            departureTime: ''
        };
        toast.info(`Added Trip #${newIndex + 1}. Please set arrival time.`);
        return { ...prev, timings: [...(prev.timings || []), newTiming] };
    });
};

const removeTimingTrip = (index) => {
    setStopEditForm(prev => {
        if ((prev.timings || []).length <= 1) {
            toast.warning('At least one timing is required');
            return prev;
        }
        const updatedTimings = (prev.timings || [])
            .filter((_, i) => i !== index)
            .map((t, i) => ({ ...t, timeSlotSequence: i + 1 }));
        toast.info(`Removed Trip #${index + 1}`);
        return { ...prev, timings: updatedTimings };
    });
};

    return (
        <div className="modal-overlay" onClick={() => setShowStopEditModal(false)}>
            <div className="modal-content stop-edit-modal" onClick={(e) => e.stopPropagation()}>
                <div className="modal-header">
                    <h3>
                        {isEditing ? `Edit Stop #${editingStopData?.sequence || ''}` : 'Add New Stop'}
                        {isEditing && editingStopData?.city && ` — ${editingStopData.city}`}
                    </h3>
                    <button className="modal-close-btn" onClick={() => setShowStopEditModal(false)}>×</button>
                </div>

                <div className="modal-body stop-edit-body">
                    {/* Manual Toggle */}
                    <div className="form-row" style={{ marginBottom: '16px' }}>
                        <Checkbox
                            label="Manually Typed Stop (No Map Suggestions)"
                            checked={stopEditForm.isManualStop}
                            onChange={() => setStopEditForm(prev => ({
                                ...prev,
                                isManualStop: !prev.isManualStop,
                                manualDistFromPrev: !prev.isManualStop ? '' : prev.manualDistFromPrev
                            }))}
                        />
                    </div>

                    {/* City */}
                    <div className="form-group" style={{ marginBottom: '12px' }}>
                        <label>Search City *</label>
                        <input
                            type="text"
                            value={stopEditForm.city}
                            onChange={(e) => setStopEditForm(prev => ({ ...prev, city: e.target.value }))}
                            placeholder="Type city name (min 2 characters)..."
                            className="form-input"
                        />
                        <small className="helper-text">Type at least 2 characters to search for cities from existing routes</small>
                    </div>

                    {/* Address */}
                    <div className="form-group" style={{ marginBottom: '12px' }}>
                        <label>Address</label>
                        <input
                            type="text"
                            value={stopEditForm.address}
                            onChange={(e) => setStopEditForm(prev => ({ ...prev, address: e.target.value }))}
                            placeholder="Complete address of the stop location"
                            className="form-input"
                        />
                        <small className="helper-text">Complete address of the stop location</small>
                    </div>

                    {/* State & Terminal */}
                    <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '12px', marginBottom: '12px' }}>
                        <div className="form-group">
                            <label>State</label>
                            <input
                                type="text"
                                value={stopEditForm.state}
                                onChange={(e) => setStopEditForm(prev => ({ ...prev, state: e.target.value }))}
                                placeholder="State"
                                className="form-input"
                            />
                        </div>
                        <div className="form-group">
                            <label>Terminal</label>
                            <input
                                type="text"
                                value={stopEditForm.terminal}
                                onChange={(e) => setStopEditForm(prev => ({ ...prev, terminal: e.target.value }))}
                                placeholder="Terminal name"
                                className="form-input"
                            />
                        </div>
                    </div>

                    {/* ========== UPDATED TIMINGS SECTION ========== */}
                    <div className="timings-section" style={{ marginBottom: '16px' }}>
                        <div style={{ 
                            display: 'flex', 
                            justifyContent: 'space-between', 
                            alignItems: 'center', 
                            marginBottom: '12px',
                            flexWrap: 'wrap',
                            gap: '8px'
                        }}>
                            <label style={{ fontWeight: '600', fontSize: '15px' }}>
                                🕐 Timings for each trip: {numberOfTrips} {numberOfTrips === 1 ? 'trip' : 'trips'} per day
                            </label>
                            <button
                                className="btn btn-sm btn-add-timing"
                                onClick={addTimingTrip}
                                style={{
                                    padding: '4px 14px',
                                    fontSize: '12px',
                                    background: '#28a745',
                                    color: 'white',
                                    border: 'none',
                                    borderRadius: '4px',
                                    cursor: 'pointer'
                                }}
                            >
                                + Add Trip
                            </button>
                        </div>

                        <div style={{
                            border: '1px solid #e0e0e0',
                            borderRadius: '8px',
                            overflow: 'hidden'
                        }}>
                            <table style={{ width: '100%', borderCollapse: 'collapse' }}>
                                <thead>
                                    <tr style={{ backgroundColor: '#f8f9fa', borderBottom: '1px solid #e0e0e0' }}>
                                        <th style={{ padding: '10px', textAlign: 'left', fontSize: '13px', width: '80px' }}>Trip</th>
                                        <th style={{ padding: '10px', textAlign: 'left', fontSize: '13px' }}>Arrival Time *</th>
                                        <th style={{ padding: '10px', textAlign: 'left', fontSize: '13px' }}>Departure Time</th>
                                        <th style={{ padding: '10px', textAlign: 'center', fontSize: '13px', width: '50px' }}>Action</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {(stopEditForm.timings || []).map((timing, idx) => (
                                        <tr key={idx} style={{ 
                                            borderBottom: idx < (stopEditForm.timings || []).length - 1 ? '1px solid #f0f0f0' : 'none',
                                            backgroundColor: idx % 2 === 0 ? '#fafafa' : 'white'
                                        }}>
                                            <td style={{ padding: '10px', fontSize: '13px', fontWeight: '500' }}>
                                                <span style={{
                                                    display: 'inline-block',
                                                    padding: '2px 10px',
                                                    borderRadius: '12px',
                                                    backgroundColor: '#e3f2fd',
                                                    color: '#0d47a1',
                                                    fontSize: '12px'
                                                }}>
                                                    #{timing.timeSlotSequence || idx + 1}
                                                </span>
                                            </td>
                                            <td style={{ padding: '10px' }}>
                                                <TimePicker
                                                    value={timing.arrivalTime}
                                                    onChange={(value) => updateTiming(idx, 'arrivalTime', value)}
                                                    placeholder="--:--"
                                                />
                                            </td>
                                            <td style={{ padding: '10px' }}>
                                                <TimePicker
                                                    value={timing.departureTime}
                                                    onChange={(value) => updateTiming(idx, 'departureTime', value)}
                                                    placeholder="--:--"
                                                />
                                            </td>
                                            <td style={{ padding: '10px', textAlign: 'center' }}>
                                                {(stopEditForm.timings || []).length > 1 && (
                                                    <button
                                                        onClick={() => removeTimingTrip(idx)}
                                                        style={{
                                                            padding: '2px 8px',
                                                            fontSize: '12px',
                                                            background: '#dc3545',
                                                            color: 'white',
                                                            border: 'none',
                                                            borderRadius: '4px',
                                                            cursor: 'pointer'
                                                        }}
                                                        title="Remove this trip"
                                                    >
                                                        ×
                                                    </button>
                                                )}
                                            </td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        </div>
                        
                        {/* ========== FIX: Add validation message ========== */}
                        {stopEditForm.timings && stopEditForm.timings.some(t => !t.arrivalTime) && (
                            <small className="helper-text" style={{ display: 'block', marginTop: '8px', color: '#dc3545' }}>
                                ⚠️ Please set arrival time for all trips
                            </small>
                        )}
                        
                        <small className="helper-text" style={{ display: 'block', marginTop: '4px', color: '#666' }}>
                            Tip: Set arrival and departure times for each trip separately
                        </small>
                    </div>

                    {/* Distance from Previous Stop */}
                    <div className="form-group" style={{ marginBottom: '12px' }}>
                        <label>Distance from Previous Stop (km) *</label>
                        <input
                            type="number"
                            value={stopEditForm.manualDistFromPrev}
                            onChange={(e) => setStopEditForm(prev => ({ ...prev, manualDistFromPrev: e.target.value }))}
                            placeholder="e.g., 1.3"
                            className="form-input"
                            min="0"
                            step="0.1"
                        />
                        {stopEditForm.distanceFromOrigin > 0 && (
                            <small className="helper-text" style={{ color: '#28a745' }}>
                                ✓ Distance from origin: {stopEditForm.distanceFromOrigin} km
                            </small>
                        )}
                        {stopEditForm.isManualStop && (
                            <small className="helper-text" style={{ color: '#dc3545' }}>
                                ⚠️ Required for manual stops
                            </small>
                        )}
                    </div>

                   
                    {/* ========== FIX: Info banner for multi-trip ========== */}
                    {numberOfTrips > 1 && (
                        <div style={{
                            marginTop: '12px',
                            padding: '10px 14px',
                            backgroundColor: '#e3f2fd',
                            borderRadius: '6px',
                            border: '1px solid #90caf9',
                            fontSize: '12px',
                            color: '#0d47a1',
                            display: 'flex',
                            alignItems: 'center',
                            gap: '8px'
                        }}>
                            <span style={{ fontSize: '16px' }}>ℹ️</span>
                            <span>
                                This stop has <strong>{numberOfTrips}</strong> trip timings. 
                                Each trip has its own arrival and departure time.
                            </span>
                        </div>
                    )}
                </div>

                <div className="modal-footer">
                    {isEditing && (
                        <button
                            className="btn btn-danger"
                            onClick={() => handleDeleteStop(stopEditForm.routeId, stopEditForm.direction, stopEditForm.stopId)}
                            style={{
                                marginRight: 'auto',
                                padding: '8px 20px',
                                background: '#dc3545',
                                color: 'white',
                                border: 'none',
                                borderRadius: '6px',
                                cursor: 'pointer'
                            }}
                        >
                            Delete Stop
                        </button>
                    )}
                    <button
                        className="btn btn-secondary"
                        onClick={() => setShowStopEditModal(false)}
                        style={{
                            padding: '8px 24px',
                            borderRadius: '6px',
                            border: '1px solid #dee2e6',
                            background: 'white',
                            cursor: 'pointer'
                        }}
                    >
                        Cancel
                    </button>
                    <button
                        className="btn btn-primary"
                        onClick={handleSaveStopEdit}
                        style={{
                            padding: '8px 24px',
                            borderRadius: '6px',
                            border: 'none',
                            background: '#007bff',
                            color: 'white',
                            cursor: 'pointer'
                        }}
                        disabled={!stopEditForm.city.trim() || !stopEditForm.timings || stopEditForm.timings.some(t => !t.arrivalTime)}
                    >
                        Save Changes
                    </button>
                </div>
            </div>
        </div>
    );
};
const renderEditableRouteDetails = (route, direction) => {
    if (!route) return null;

    // ========== Get the latest route data from editForm ==========
    const latestRoute = direction === 'UP' ? 
        editForm.routeSchedules?.find(r => r.direction === 'UP') : 
        editForm.routeSchedules?.find(r => r.direction === 'DOWN');
    
    // Use the latest route data if available, otherwise fallback to the passed route
    const currentRoute = latestRoute || route;
    const isMultiTrip = currentRoute.origin?.timings && currentRoute.origin.timings.length > 0;

    const updateRouteField = (field, value) => {
        const updatedRoute = { ...currentRoute, [field]: value };
        updateRouteInEditForm(direction, updatedRoute);
        
        // Also update scheduleData to keep it in sync
        setScheduleData(prev => {
            const routeSchedules = prev?.routeSchedules || [];
            const index = routeSchedules.findIndex(r => r.direction === direction);
            if (index >= 0) {
                const newRouteSchedules = [...routeSchedules];
                newRouteSchedules[index] = { ...newRouteSchedules[index], ...updatedRoute };
                return { ...prev, routeSchedules: newRouteSchedules };
            }
            return prev;
        });
        
        // Force re-render
        setRefreshKey(prev => prev + 1);
    };



//     const updateOriginField = (field, value) => {
//     const updatedRoute = {
//         ...currentRoute,
//         origin: { ...currentRoute.origin, [field]: value }
//     };
//     updateRouteInEditForm(direction, updatedRoute);
    
//     // If departure time changed, trigger duration recalculation
//     if (field === 'departureTime' || field === 'timings') {
//         // The useEffect will handle the recalculation
//         setEditForm(prev => {
//             const routeSchedules = [...(prev.routeSchedules || [])];
//             const index = routeSchedules.findIndex(r => r.direction === direction);
//             if (index >= 0) {
//                 routeSchedules[index] = { ...routeSchedules[index], ...updatedRoute };
//             }
//             return { ...prev, routeSchedules };
//         });
//     }
    
//     setScheduleData(prev => {
//         const routeSchedules = prev?.routeSchedules || [];
//         const index = routeSchedules.findIndex(r => r.direction === direction);
//         if (index >= 0) {
//             const newRouteSchedules = [...routeSchedules];
//             newRouteSchedules[index] = { ...newRouteSchedules[index], ...updatedRoute };
//             return { ...prev, routeSchedules: newRouteSchedules };
//         }
//         return prev;
//     });
    
//     setRefreshKey(prev => prev + 1);
// };

const updateOriginField = (field, value) => {
    const updatedRoute = {
        ...currentRoute,
        origin: { ...currentRoute.origin, [field]: value }
    };
    
    // ========== SYNC: Update additionalBoardingPoints for origin ==========
    if (field === 'city' || field === 'terminal' || field === 'address' || field === 'state' || field === 'timings' || field === 'departureTime') {
        let boardingPoints = [...(currentRoute.additionalBoardingPoints || [])];
        
        // Get the timings from origin
        const originTimings = updatedRoute.origin?.timings || [];
        const firstTiming = originTimings[0] || { departureTime: '' };
        
        // Find the origin boarding point - by city match or isOrigin flag
        const originPointIndex = boardingPoints.findIndex(p => 
            p.isOrigin === true || 
            (p.city && p.city.toLowerCase() === updatedRoute.origin?.city?.toLowerCase()) ||
            (p.name && p.name.toLowerCase() === updatedRoute.origin?.terminal?.toLowerCase())
        );
        
        if (originPointIndex >= 0) {
            // Update existing origin boarding point
            boardingPoints[originPointIndex] = {
                ...boardingPoints[originPointIndex],
                name: updatedRoute.origin.terminal || updatedRoute.origin.city,
                address: updatedRoute.origin.address || boardingPoints[originPointIndex].address,
                city: updatedRoute.origin.city || boardingPoints[originPointIndex].city,
                state: updatedRoute.origin.state || boardingPoints[originPointIndex].state,
                landmark: updatedRoute.origin.terminal || updatedRoute.origin.city,
                pickupTime: firstTiming.departureTime || boardingPoints[originPointIndex].pickupTime || '',
                timings: originTimings.map(t => ({
                    timeSlotSequence: t.timeSlotSequence || 1,
                    pickupTime: t.departureTime || ''
                })),
                isOrigin: true
            };
        } else {
            // No existing origin point found, create new one
            boardingPoints.unshift({
                name: updatedRoute.origin.terminal || updatedRoute.origin.city,
                address: updatedRoute.origin.address || '',
                city: updatedRoute.origin.city || '',
                state: updatedRoute.origin.state || '',
                landmark: updatedRoute.origin.terminal || updatedRoute.origin.city,
                pickupTime: firstTiming.departureTime || '',
                timings: originTimings.map(t => ({
                    timeSlotSequence: t.timeSlotSequence || 1,
                    pickupTime: t.departureTime || ''
                })),
                isEnabled: true,
                isOrigin: true,
                dateOverrides: []
            });
        }
        
        // Clean up: Remove any duplicate origin points (keep only the first one)
        const uniqueBoardingPoints = [];
        let foundOrigin = false;
        for (const point of boardingPoints) {
            if (point.isOrigin === true) {
                if (!foundOrigin) {
                    uniqueBoardingPoints.push(point);
                    foundOrigin = true;
                }
                // Skip duplicates
            } else {
                uniqueBoardingPoints.push(point);
            }
        }
        boardingPoints = uniqueBoardingPoints;
        
        updatedRoute.additionalBoardingPoints = boardingPoints;
    }
    
    updateRouteInEditForm(direction, updatedRoute);
    
    // If departure time changed, trigger duration recalculation
    if (field === 'departureTime' || field === 'timings') {
        setEditForm(prev => {
            const routeSchedules = [...(prev.routeSchedules || [])];
            const index = routeSchedules.findIndex(r => r.direction === direction);
            if (index >= 0) {
                routeSchedules[index] = { ...routeSchedules[index], ...updatedRoute };
            }
            return { ...prev, routeSchedules };
        });
    }
    
    setScheduleData(prev => {
        const routeSchedules = prev?.routeSchedules || [];
        const index = routeSchedules.findIndex(r => r.direction === direction);
        if (index >= 0) {
            const newRouteSchedules = [...routeSchedules];
            newRouteSchedules[index] = { ...newRouteSchedules[index], ...updatedRoute };
            return { ...prev, routeSchedules: newRouteSchedules };
        }
        return prev;
    });
    
    setRefreshKey(prev => prev + 1);
};

// const updateDestField = (field, value) => {
//     const updatedRoute = {
//         ...currentRoute,
//         destination: { ...currentRoute.destination, [field]: value }
//     };
//     updateRouteInEditForm(direction, updatedRoute);
    
//     // If arrival time changed, trigger duration recalculation
//     if (field === 'arrivalTime' || field === 'timings') {
//         // The useEffect will handle the recalculation
//         setEditForm(prev => {
//             const routeSchedules = [...(prev.routeSchedules || [])];
//             const index = routeSchedules.findIndex(r => r.direction === direction);
//             if (index >= 0) {
//                 routeSchedules[index] = { ...routeSchedules[index], ...updatedRoute };
//             }
//             return { ...prev, routeSchedules };
//         });
//     }
    
//     setScheduleData(prev => {
//         const routeSchedules = prev?.routeSchedules || [];
//         const index = routeSchedules.findIndex(r => r.direction === direction);
//         if (index >= 0) {
//             const newRouteSchedules = [...routeSchedules];
//             newRouteSchedules[index] = { ...newRouteSchedules[index], ...updatedRoute };
//             return { ...prev, routeSchedules: newRouteSchedules };
//         }
//         return prev;
//     });
    
//     setRefreshKey(prev => prev + 1);
// };

const updateDestField = (field, value) => {
    const updatedRoute = {
        ...currentRoute,
        destination: { ...currentRoute.destination, [field]: value }
    };
    
    // ========== SYNC: Update additionalDroppingPoints for destination ==========
    if (field === 'city' || field === 'terminal' || field === 'address' || field === 'state' || field === 'timings' || field === 'arrivalTime') {
        let droppingPoints = [...(currentRoute.additionalDroppingPoints || [])];
        
        // Get the timings from destination
        const destTimings = updatedRoute.destination?.timings || [];
        const firstTiming = destTimings[0] || { arrivalTime: '' };
        
        // Find the destination dropping point - by city match or isDestination flag
        const destPointIndex = droppingPoints.findIndex(p => 
            p.isDestination === true || 
            (p.city && p.city.toLowerCase() === updatedRoute.destination?.city?.toLowerCase()) ||
            (p.name && p.name.toLowerCase() === updatedRoute.destination?.terminal?.toLowerCase())
        );
        
        if (destPointIndex >= 0) {
            // Update existing destination dropping point
            droppingPoints[destPointIndex] = {
                ...droppingPoints[destPointIndex],
                name: updatedRoute.destination.terminal || updatedRoute.destination.city,
                address: updatedRoute.destination.address || droppingPoints[destPointIndex].address,
                city: updatedRoute.destination.city || droppingPoints[destPointIndex].city,
                state: updatedRoute.destination.state || droppingPoints[destPointIndex].state,
                landmark: updatedRoute.destination.terminal || updatedRoute.destination.city,
                dropTime: firstTiming.arrivalTime || droppingPoints[destPointIndex].dropTime || '',
                timings: destTimings.map(t => ({
                    timeSlotSequence: t.timeSlotSequence || 1,
                    dropTime: t.arrivalTime || ''
                })),
                isDestination: true
            };
        } else {
            // No existing destination point found, create new one
            droppingPoints.push({
                name: updatedRoute.destination.terminal || updatedRoute.destination.city,
                address: updatedRoute.destination.address || '',
                city: updatedRoute.destination.city || '',
                state: updatedRoute.destination.state || '',
                landmark: updatedRoute.destination.terminal || updatedRoute.destination.city,
                dropTime: firstTiming.arrivalTime || '',
                timings: destTimings.map(t => ({
                    timeSlotSequence: t.timeSlotSequence || 1,
                    dropTime: t.arrivalTime || ''
                })),
                isEnabled: true,
                isDestination: true,
                dateOverrides: []
            });
        }
        
        // Clean up: Remove any duplicate destination points (keep only the first one)
        const uniqueDroppingPoints = [];
        let foundDestination = false;
        for (const point of droppingPoints) {
            if (point.isDestination === true) {
                if (!foundDestination) {
                    uniqueDroppingPoints.push(point);
                    foundDestination = true;
                }
                // Skip duplicates
            } else {
                uniqueDroppingPoints.push(point);
            }
        }
        droppingPoints = uniqueDroppingPoints;
        
        updatedRoute.additionalDroppingPoints = droppingPoints;
    }
    
    updateRouteInEditForm(direction, updatedRoute);
    
    // If arrival time changed, trigger duration recalculation
    if (field === 'arrivalTime' || field === 'timings') {
        setEditForm(prev => {
            const routeSchedules = [...(prev.routeSchedules || [])];
            const index = routeSchedules.findIndex(r => r.direction === direction);
            if (index >= 0) {
                routeSchedules[index] = { ...routeSchedules[index], ...updatedRoute };
            }
            return { ...prev, routeSchedules };
        });
    }
    
    setScheduleData(prev => {
        const routeSchedules = prev?.routeSchedules || [];
        const index = routeSchedules.findIndex(r => r.direction === direction);
        if (index >= 0) {
            const newRouteSchedules = [...routeSchedules];
            newRouteSchedules[index] = { ...newRouteSchedules[index], ...updatedRoute };
            return { ...prev, routeSchedules: newRouteSchedules };
        }
        return prev;
    });
    
    setRefreshKey(prev => prev + 1);
};

    const updateRouteDetails = (field, value) => {
        const updatedRoute = {
            ...currentRoute,
            routeDetails: { ...currentRoute.routeDetails, [field]: value }
        };
        updateRouteInEditForm(direction, updatedRoute);
        
        setScheduleData(prev => {
            const routeSchedules = prev?.routeSchedules || [];
            const index = routeSchedules.findIndex(r => r.direction === direction);
            if (index >= 0) {
                const newRouteSchedules = [...routeSchedules];
                newRouteSchedules[index] = { ...newRouteSchedules[index], ...updatedRoute };
                return { ...prev, routeSchedules: newRouteSchedules };
            }
            return prev;
        });
        
        setRefreshKey(prev => prev + 1);
    };

    // Function to update intermediate stops
    const updateIntermediateStops = (updatedStops) => {
        const updatedRoute = {
            ...currentRoute,
            intermediateStops: updatedStops
        };
        updateRouteInEditForm(direction, updatedRoute);
        
        setScheduleData(prev => {
            const routeSchedules = prev?.routeSchedules || [];
            const index = routeSchedules.findIndex(r => r.direction === direction);
            if (index >= 0) {
                const newRouteSchedules = [...routeSchedules];
                newRouteSchedules[index] = { ...newRouteSchedules[index], ...updatedRoute };
                return { ...prev, routeSchedules: newRouteSchedules };
            }
            return prev;
        });
        
        setRefreshKey(prev => prev + 1);
    };

    return (
        <div className="route-details-section editable" key={`route-${direction}-${refreshKey}`}>
            <div style={{
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'center',
                marginBottom: '16px',
                paddingBottom: '12px',
                borderBottom: '2px solid #f1f3f5'
            }}>
                <h4 style={{ margin: 0, fontSize: '18px', fontWeight: '600', color: '#2c3e50' }}>
                    {direction} Route
                </h4>
                <span className={`status-badge ${currentRoute.isActive !== false ? 'active' : 'inactive'}`}>
                    {currentRoute.isActive !== false ? 'Active' : 'Inactive'}
                </span>
            </div>

            {/* Route Info */}
            <div className="edit-form-grid">
                <div className="form-group">
                    <label>Route Name</label>
                    <input
                        type="text"
                        value={currentRoute.routeName || ''}
                        onChange={(e) => updateRouteField('routeName', e.target.value)}
                        className="form-input"
                        placeholder="Route name"
                    />
                </div>

                <div className="form-group">
                    <label>Route Number</label>
                    <input
                        type="text"
                        value={currentRoute.routeNumber || ''}
                        onChange={(e) => updateRouteField('routeNumber', e.target.value)}
                        className="form-input"
                        placeholder="Route number"
                    />
                </div>

                <div className="form-group">
                    <label>Operating Days</label>
                    <input
                        type="text"
                        value={(currentRoute.operatingDays || []).join(', ')}
                        onChange={(e) => {
                            const days = e.target.value.split(',').map(s => s.trim()).filter(Boolean);
                            updateRouteField('operatingDays', days);
                        }}
                        className="form-input"
                        placeholder="Monday, Tuesday, Wednesday"
                    />
                    <small className="helper-text">Separate days with commas</small>
                </div>

                <div className="form-group">
                    <label>Total Distance (km)</label>
                    <input
                        type="number"
                        value={currentRoute.routeDetails?.totalDistance || 0}
                        onChange={(e) => updateRouteDetails('totalDistance', parseFloat(e.target.value) || 0)}
                        className="form-input"
                        min="0"
                        step="0.1"
                    />
                </div>

                <div className="form-group">
                    <label>Duration (Hours)</label>
                    <input
                        type="number"
                        value={currentRoute.routeDetails?.estimatedDuration?.hours || 0}
                        onChange={(e) => {
                            const hours = parseInt(e.target.value) || 0;
                            updateRouteDetails('estimatedDuration', {
                                ...currentRoute.routeDetails?.estimatedDuration,
                                hours
                            });
                        }}
                        className="form-input"
                        min="0"
                    />
                </div>

                <div className="form-group">
                    <label>Duration (Minutes)</label>
                    <input
                        type="number"
                        value={currentRoute.routeDetails?.estimatedDuration?.minutes || 0}
                        onChange={(e) => {
                            const minutes = parseInt(e.target.value) || 0;
                            updateRouteDetails('estimatedDuration', {
                                ...currentRoute.routeDetails?.estimatedDuration,
                                minutes: Math.min(59, minutes)
                            });
                        }}
                        className="form-input"
                        min="0"
                        max="59"
                    />
                </div>
            </div>

            {/* Origin */}
            <div style={{
                background: '#f8f9fa',
                borderRadius: '8px',
                padding: '16px',
                marginBottom: '16px'
            }}>
                <h5 style={{ margin: '0 0 12px 0', color: '#2c3e50' }}>📍 Origin</h5>
                <div className="edit-form-grid" style={{
                    display: 'grid',
                    gridTemplateColumns: 'repeat(auto-fill, minmax(200px, 1fr))',
                    gap: '12px'
                }}>
                    <div className="form-group">
                        <label>City</label>
                        <input
                            type="text"
                            value={currentRoute.origin?.city || ''}
                            onChange={(e) => updateOriginField('city', e.target.value)}
                            className="form-input"
                            placeholder="City name"
                        />
                    </div>
                    <div className="form-group">
                        <label>State</label>
                        <input
                            type="text"
                            value={currentRoute.origin?.state || ''}
                            onChange={(e) => updateOriginField('state', e.target.value)}
                            className="form-input"
                            placeholder="State"
                        />
                    </div>
                    <div className="form-group">
                        <label>Terminal</label>
                        <input
                            type="text"
                            value={currentRoute.origin?.terminal || ''}
                            onChange={(e) => updateOriginField('terminal', e.target.value)}
                            className="form-input"
                            placeholder="Terminal name"
                        />
                    </div>
                    <div className="form-group" style={{ gridColumn: '1 / -1' }}>
                        <label>Address</label>
                        <input
                            type="text"
                            value={currentRoute.origin?.address || ''}
                            onChange={(e) => updateOriginField('address', e.target.value)}
                            className="form-input"
                            placeholder="Full address"
                        />
                    </div>
                </div>

                <div style={{ marginTop: '8px' }}>
                    <label>Departure Times {isMultiTrip ? '(Multi-Trip)' : ''}</label>
                    {isMultiTrip ? (
                        <div>
                            {currentRoute.origin?.timings?.map((timing, idx) => (
                                <div key={timing.timeSlotSequence || idx} style={{
                                    display: 'flex',
                                    alignItems: 'center',
                                    gap: '12px',
                                    marginTop: '4px'
                                }}>
                                    <span style={{ fontWeight: '500', minWidth: '60px' }}>
                                        Trip {timing.timeSlotSequence || idx + 1}:
                                    </span>
                                    <TimePicker
                                        value={timing.departureTime}
                                        onChange={(value) => {
                                            const updatedTimings = [...(currentRoute.origin?.timings || [])];
                                            updatedTimings[idx] = { ...timing, departureTime: value };
                                            updateOriginField('timings', updatedTimings);
                                        }}
                                        placeholder="--:--"
                                    />
                                </div>
                            ))}
                            <button
                                type="button"
                                className="btn btn-sm btn-add-timing"
                                onClick={() => {
                                    const timings = currentRoute.origin?.timings || [];
                                    const newTiming = {
                                        timeSlotSequence: timings.length + 1,
                                        departureTime: '',
                                        arrivalTime: ''
                                    };
                                    updateOriginField('timings', [...timings, newTiming]);
                                }}
                                style={{
                                    marginTop: '8px',
                                    padding: '4px 12px',
                                    fontSize: '12px',
                                    background: '#28a745',
                                    color: 'white',
                                    border: 'none',
                                    borderRadius: '4px',
                                    cursor: 'pointer'
                                }}
                            >
                                + Add Trip
                            </button>
                        </div>
                    ) : (
                        <TimePicker
                            value={currentRoute.origin?.departureTime}
                            onChange={(value) => updateOriginField('departureTime', value)}
                            placeholder="Select time"
                        />
                    )}
                </div>
            </div>

            {/* Destination */}
            <div style={{
                background: '#f8f9fa',
                borderRadius: '8px',
                padding: '16px',
                marginBottom: '16px'
            }}>
                <h5 style={{ margin: '0 0 12px 0', color: '#2c3e50' }}>🏁 Destination</h5>
                <div className="edit-form-grid" style={{
                    display: 'grid',
                    gridTemplateColumns: 'repeat(auto-fill, minmax(200px, 1fr))',
                    gap: '12px'
                }}>
                    <div className="form-group">
                        <label>City</label>
                        <input
                            type="text"
                            value={currentRoute.destination?.city || ''}
                            onChange={(e) => updateDestField('city', e.target.value)}
                            className="form-input"
                            placeholder="City name"
                        />
                    </div>
                    <div className="form-group">
                        <label>State</label>
                        <input
                            type="text"
                            value={currentRoute.destination?.state || ''}
                            onChange={(e) => updateDestField('state', e.target.value)}
                            className="form-input"
                            placeholder="State"
                        />
                    </div>
                    <div className="form-group">
                        <label>Terminal</label>
                        <input
                            type="text"
                            value={currentRoute.destination?.terminal || ''}
                            onChange={(e) => updateDestField('terminal', e.target.value)}
                            className="form-input"
                            placeholder="Terminal name"
                        />
                    </div>
                    <div className="form-group">
                        <label>Distance from Origin (km)</label>
                        <input
                            type="number"
                            value={currentRoute.destination?.distanceFromOrigin || 0}
                            onChange={(e) => updateDestField('distanceFromOrigin', parseFloat(e.target.value) || 0)}
                            className="form-input"
                            min="0"
                            step="0.1"
                        />
                    </div>
                    <div className="form-group" style={{ gridColumn: '1 / -1' }}>
                        <label>Address</label>
                        <input
                            type="text"
                            value={currentRoute.destination?.address || ''}
                            onChange={(e) => updateDestField('address', e.target.value)}
                            className="form-input"
                            placeholder="Full address"
                        />
                    </div>
                </div>

                <div style={{ marginTop: '8px' }}>
                    <label>Arrival Times {isMultiTrip ? '(Multi-Trip)' : ''}</label>
                    {isMultiTrip ? (
                        <div>
                            {currentRoute.destination?.timings?.map((timing, idx) => (
                                <div key={timing.timeSlotSequence || idx} style={{
                                    display: 'flex',
                                    alignItems: 'center',
                                    gap: '12px',
                                    marginTop: '4px'
                                }}>
                                    <span style={{ fontWeight: '500', minWidth: '60px' }}>
                                        Trip {timing.timeSlotSequence || idx + 1}:
                                    </span>
                                    <TimePicker
                                        value={timing.arrivalTime}
                                        onChange={(value) => {
                                            const updatedTimings = [...(currentRoute.destination?.timings || [])];
                                            updatedTimings[idx] = { ...timing, arrivalTime: value };
                                            updateDestField('timings', updatedTimings);
                                        }}
                                        placeholder="--:--"
                                    />
                                </div>
                            ))}
                            <button
                                type="button"
                                className="btn btn-sm btn-add-timing"
                                onClick={() => {
                                    const timings = currentRoute.destination?.timings || [];
                                    const newTiming = {
                                        timeSlotSequence: timings.length + 1,
                                        arrivalTime: '',
                                        departureTime: ''
                                    };
                                    updateDestField('timings', [...timings, newTiming]);
                                }}
                                style={{
                                    marginTop: '8px',
                                    padding: '4px 12px',
                                    fontSize: '12px',
                                    background: '#28a745',
                                    color: 'white',
                                    border: 'none',
                                    borderRadius: '4px',
                                    cursor: 'pointer'
                                }}
                            >
                                + Add Trip
                            </button>
                        </div>
                    ) : (
                        <TimePicker
                            value={currentRoute.destination?.arrivalTime}
                            onChange={(value) => updateDestField('arrivalTime', value)}
                            placeholder="Select time"
                        />
                    )}
                </div>
            </div>

            {/* Intermediate Stops - FIXED */}
            {currentRoute.intermediateStops && currentRoute.intermediateStops.length > 0 ? (
                <div className="stops-section" key={`stops-section-${direction}-${refreshKey}`}>
                    <div className="stops-section-header">
                        <h5>🚏 Intermediate Stops ({currentRoute.intermediateStops.length})</h5>
                        <button
                            className="btn btn-sm btn-add-stop"
                            onClick={() => handleOpenAddStop(currentRoute.routeId, direction)}
                        >
                            + Add Stop
                        </button>
                    </div>
                    {renderStopsWithInlineInsert(currentRoute, direction, currentRoute.intermediateStops)}
                </div>
            ) : (
                <div className="stops-empty-section">
                    <h5>🚏 Intermediate Stops</h5>
                    <p>No intermediate stops configured for this route.</p>
                    <button
                        className="btn btn-primary btn-sm"
                        onClick={() => handleOpenAddStop(currentRoute.routeId, direction)}
                    >
                        + Add First Stop
                    </button>
                </div>
            )}
        </div>
    );
};

    // Clear search timeout
    useEffect(() => {
        return () => {
            if (searchTimeoutRef.current) {
                clearTimeout(searchTimeoutRef.current);
            }
        };
    }, []);

    if (loading && schedules.length === 0) {
        return (
            <div className="management-page">
                <div className="page-header">
                    <div className="skeleton-header-title"></div>
                    <div className="header-actions">
                        <div className="skeleton-search"></div>
                        <div className="skeleton-button"></div>
                    </div>
                </div>
                <div className="stats-cards">
                    {[1, 2, 3, 4].map((i) => (
                        <SkeletonStatsCard key={i} />
                    ))}
                </div>
                <div className="table-container">
                    <table className="data-table">
                        <thead>
                            <tr>
                                <th>No.</th>
                                <th>Bus Name</th>
                                <th>Bus Number</th>
                                <th>Route</th>
                                <th>Origin</th>
                                <th>Destination</th>
                                <th>Distance</th>
                                <th>Stops</th>
                                <th>Status</th>
                                <th>Actions</th>
                            </tr>
                        </thead>
                        <tbody>
                            {[1, 2, 3, 4, 5, 6, 7, 8, 9, 10].map((i) => (
                                <SkeletonTableRow key={i} />
                            ))}
                        </tbody>
                    </table>
                </div>
                <div className="pagination-container">
                    <div className="skeleton-pagination-info"></div>
                    <div className="skeleton-pagination-controls"></div>
                </div>
            </div>
        );
    }

    return (
        <div className="management-page">
            <div className="page-header">
                <h1>Bus Route Schedule Management</h1>
                <div className="header-actions">
                    <input
                        type="text"
                        placeholder="Search by bus name, number or route..."
                        className="search-input"
                        value={searchTerm}
                        onChange={handleSearch}
                        style={{ minWidth: '250px' }}
                    />
                    <select
                        className="filter-select"
                        value={filterStatus}
                        onChange={(e) => handleFilterChange('status', e.target.value)}
                    >
                        <option value="">All Status</option>
                        <option value="true">Active</option>
                        <option value="false">Inactive</option>
                    </select>
                    <select
                        className="filter-select"
                        value={filterBusType}
                        onChange={(e) => handleFilterChange('busType', e.target.value)}
                    >
                        <option value="">All Bus Types</option>
                        <option value="AC">AC</option>
                        <option value="Non-AC">Non-AC</option>
                        <option value="Sleeper">Sleeper</option>
                        <option value="Seater">Seater</option>
                    </select>
                    <select
                        className="filter-select"
                        value={filterRouteType}
                        onChange={(e) => handleFilterChange('routeType', e.target.value)}
                    >
                        <option value="">All Route Types</option>
                        <option value="Round Trip">Round Trip</option>
                        <option value="UP">One Way (UP)</option>
                        <option value="DOWN">One Way (DOWN)</option>
                    </select>
                    <button className="refresh-btn" onClick={fetchSchedules}>
                        ↻ Refresh
                    </button>
                </div>
            </div>

            <div className="stats-cards">
                <div className="stat-card">
                    <h3>Total Buses</h3>
                    <p>{stats.total || 0}</p>
                    <span>With route schedules</span>
                </div>
                <div className="stat-card">
                    <h3>With Schedules</h3>
                    <p>{stats.withSchedules || 0}</p>
                    <span>Buses having route assigned</span>
                </div>
                <div className="stat-card">
                    <h3>Active</h3>
                    <p>{stats.active || 0}</p>
                    <span>Currently active</span>
                </div>
                <div className="stat-card">
                    <h3>Total Routes</h3>
                    <p>{schedules.reduce((acc, s) => acc + (s.summary?.numberOfRoutes || 0), 0)}</p>
                    <span>Across all buses</span>
                </div>
            </div>

            <div className="table-container">
                <table className="data-table">
                    <thead>
                        <tr>
                            <th>No.</th>
                            <th>Bus Name</th>
                            <th>Bus Number</th>
                            <th>Route</th>
                            <th>Origin</th>
                            <th>Destination</th>
                            <th>Distance</th>
                            <th>Stops</th>
                            <th>Type</th>
                            <th>Status</th>
                            <th>Actions</th>
                        </tr>
                    </thead>
                    <tbody>
                        {schedules.length === 0 ? (
                            <tr>
                                <td colSpan="11" className="empty-row">
                                    No bus route schedules found
                                </td>
                            </tr>
                        ) : (
                            schedules.map((item, index) => {
                                const busInfo = item.busInfo || {};
                                const summary = item.summary || {};

                                return (
                                    <tr key={item._id || index}>
                                        <td>{(currentPage - 1) * pageSize + index + 1}</td>
                                        <td>
                                            <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                                                <strong>{busInfo.busName || 'N/A'}</strong>
                                                {busInfo.busClass && (
                                                    <span style={{
                                                        fontSize: '10px',
                                                        background: '#e9ecef',
                                                        padding: '2px 8px',
                                                        borderRadius: '12px'
                                                    }}>{busInfo.busClass}</span>
                                                )}
                                            </div>
                                        </td>
                                        <td>{busInfo.busNumber || 'N/A'}</td>
                                        <td>
                                            {summary.routeNames?.length > 0 ? (
                                                <span style={{ fontWeight: '500' }}>{summary.routeNames.join(', ')}</span>
                                            ) : (
                                                <span style={{ color: '#999' }}>No Route</span>
                                            )}
                                        </td>
                                        <td>{summary.origin || 'N/A'}</td>
                                        <td>{summary.destination || 'N/A'}</td>
                                        <td>{summary.totalDistance || 0} km</td>
                                        <td>{summary.totalStops || 0}</td>
                                        <td>
                                            <span className={`route-type-badge ${summary.routeType?.includes('Round') ? 'roundtrip' : 'oneway'}`}>
                                                {summary.routeType || 'N/A'}
                                            </span>
                                        </td>
                                        <td>
                                            <StatusBadge isActive={item.isActive !== false} />
                                        </td>
                                        <td>
                                            <div className="action-buttons">
                                                <button
                                                    className="action-btn edit"
                                                    onClick={() => handleEditSchedule(item)}
                                                    disabled={!summary.routeNames?.length}
                                                >
                                                    Edit
                                                </button>
                                            </div>
                                        </td>
                                    </tr>
                                );
                            })
                        )}
                    </tbody>
                </table>
            </div>

            {/* Pagination */}
            {totalPages > 1 && (
                <div className="pagination-container">
                    <div className="pagination-info">
                        Showing {Math.min(pageSize, schedules.length)} of {totalItems} buses
                        (Page {currentPage} of {totalPages})
                    </div>
                    <div className="pagination-controls">
                        <button
                            className="pagination-btn"
                            onClick={() => setCurrentPage(prev => Math.max(1, prev - 1))}
                            disabled={currentPage === 1}
                        >
                            Previous
                        </button>
                        <div className="page-numbers">
                            {Array.from({ length: Math.min(5, totalPages) }, (_, i) => {
                                let pageNumber;
                                if (totalPages <= 5) {
                                    pageNumber = i + 1;
                                } else if (currentPage <= 3) {
                                    pageNumber = i + 1;
                                } else if (currentPage >= totalPages - 2) {
                                    pageNumber = totalPages - 4 + i;
                                } else {
                                    pageNumber = currentPage - 2 + i;
                                }
                                return (
                                    <button
                                        key={pageNumber}
                                        className={`page-number ${pageNumber === currentPage ? 'active' : ''}`}
                                        onClick={() => setCurrentPage(pageNumber)}
                                    >
                                        {pageNumber}
                                    </button>
                                );
                            })}
                        </div>
                        <button
                            className="pagination-btn"
                            onClick={() => setCurrentPage(prev => Math.min(totalPages, prev + 1))}
                            disabled={currentPage === totalPages}
                        >
                            Next
                        </button>
                    </div>
                </div>
            )}

            {/* Edit Modal */}
            {showEditModal && (
                <div className="modal-overlay" onClick={() => setShowEditModal(false)}>
                    <div className="modal-content edit-route-content" onClick={(e) => e.stopPropagation()}>
                        <div className="modal-header">
                            <h3>Edit Bus Route Schedule: {editingSchedule?.busInfo?.busName || 'Bus'}</h3>
                            <button className="modal-close-btn" onClick={() => setShowEditModal(false)}>×</button>
                        </div>

                        <div className="modal-body">
                            {loadingSchedule ? (
                                <div style={{ textAlign: 'center', padding: '40px' }}>
                                    <div className="spinner"></div>
                                    <p>Loading schedule details...</p>
                                </div>
                            ) : (
                                <>
                                    {renderEditableBusInfo()}

                                 <div className="route-tabs">
    <button
        className={`route-tab ${activeRouteTab === 'UP' ? 'active' : ''}`}
        onClick={() => setActiveRouteTab('UP')}
    >
        UP Route
        {currentUpRoute && <span className="tab-badge">Active</span>}
    </button>
    <button
        className={`route-tab ${activeRouteTab === 'DOWN' ? 'active' : ''}`}
        onClick={() => setActiveRouteTab('DOWN')}
    >
        DOWN Route
        {currentDownRoute && <span className="tab-badge">Active</span>}
    </button>
    <button
        className={`route-tab ${activeRouteTab === 'ALL' ? 'active' : ''}`}
        onClick={() => setActiveRouteTab('ALL')}
    >
        All Stops & Points
    </button>
</div>

                                   <div className="route-content">
    {activeRouteTab === 'UP' && (
        currentUpRoute ? renderEditableRouteDetails(currentUpRoute, 'UP') : (
            <div className="empty-route">
                <p>No UP route configured for this bus.</p>
            </div>
        )
    )}

    {activeRouteTab === 'DOWN' && (
        currentDownRoute ? renderEditableRouteDetails(currentDownRoute, 'DOWN') : (
            <div className="empty-route">
                <p>No DOWN route configured for this bus.</p>
            </div>
        )
    )}

    {activeRouteTab === 'ALL' && (
        <div className="all-stops-section">
            <div style={{
                display: 'grid',
                gridTemplateColumns: '1fr 1fr',
                gap: '20px'
            }}>
                {currentUpRoute && (
                    <div>
                        <h4 style={{ color: '#2c3e50', marginBottom: '12px' }}>UP Route</h4>
                        {renderEditableRouteDetails(currentUpRoute, 'UP')}
                    </div>
                )}
                {currentDownRoute && (
                    <div>
                        <h4 style={{ color: '#2c3e50', marginBottom: '12px' }}>DOWN Route</h4>
                        {renderEditableRouteDetails(currentDownRoute, 'DOWN')}
                    </div>
                )}
            </div>
        </div>
    )}
</div>

                                   
                                </>
                            )}
                        </div>

                        <div className="modal-footer">
                            <button
                                className="btn btn-secondary"
                                onClick={() => setShowEditModal(false)}
                            >
                                Cancel
                            </button>
                            <button
                                className="btn btn-primary"
                                onClick={handleSaveChanges}
                                disabled={isUpdating || loadingSchedule}
                            >
                                {isUpdating ? 'Saving...' : 'Save Changes'}
                            </button>
                        </div>
                    </div>
                </div>
            )}

            {/* Stop Edit Modal */}
            {renderStopEditModal()}

            {/* Disabled Dates Modal */}
            {showDisabledDatesModal && (
                <div className="modal-overlay" onClick={() => setShowDisabledDatesModal(false)}>
                    <div className="modal-content" onClick={(e) => e.stopPropagation()}>
                        <div className="modal-header">
                            <h3>Disabled Dates</h3>
                            <button className="modal-close-btn" onClick={() => setShowDisabledDatesModal(false)}>×</button>
                        </div>
                        <div className="modal-body">
                            {disabledDates.length === 0 ? (
                                <p className="no-dates">No disabled dates found for this point.</p>
                            ) : (
                                <div className="dates-list">
                                    {disabledDates.map((item, idx) => (
                                        <div key={idx} className="date-item">
                                            <span className="date-value">
                                                {new Date(item.date).toLocaleDateString()}
                                            </span>
                                            <span className={`point-type ${item.pointType}`}>
                                                {item.pointType}
                                            </span>
                                            <span className="point-name">{item.pointName}</span>
                                        </div>
                                    ))}
                                </div>
                            )}
                        </div>
                        <div className="modal-footer">
                            <button className="btn btn-secondary" onClick={() => setShowDisabledDatesModal(false)}>
                                Close
                            </button>
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
};

export default BusRouteScheduleManage;